export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 4.36,
        "transcript": "...mat'ukun wangkuta yuilqurmiutarnun...",
        "translation": "...with this, [we would try to catch] wilderness animals..."
    },
    "2": {
        "startTime": 5.82,
        "endTime": 16.46,
        "transcript": "Mat'ukun wangkuta yuilqurmiutarmun, kuigmiutarmun-llu, neqnek-llu unangengnaqtullruukut.",
        "translation": "With this, we'd try to catch wilderness animals, riverine animals, and fish."
    },
    "3": {
        "startTime": 16.645,
        "endTime": 23.62,
        "transcript": "Unangaqluta quyurtengnaqaqamta pingnaqaqamta unangaqluta.",
        "translation": "We get them when we'd gather and subsist."
    },
    "4": {
        "startTime": 23.62,
        "endTime": 29.49,
        "transcript": "Pingnaqenrilnguq-llu caunani, arrsauluni, neqkaunani-llu.",
        "translation": "And one who doesn't subsist has nothing, is poor, and has no food."
    },
    "5": {
        "startTime": 29.49,
        "endTime": 37.39,
        "transcript": "Tua-i-gguq tauna camek quyurcingnaqenrilnguq tua-i tuaten pilaraat.",
        "translation": "They say that's what they call that one who doesn't gather anything."
    },
    "6": {
        "startTime": 37.395,
        "endTime": 41.65,
        "transcript": "Tau͡gaam-gguq pingnaqellria unangaqluni.",
        "translation": "But they said that one who subsists obtains things."
    },
    "7": {
        "startTime": 41.65,
        "endTime": 44.06,
        "transcript": "Nallemteńi tamaani",
        "translation": "Back in our time"
    },
    "8": {
        "startTime": 44.26,
        "endTime": 56.64,
        "transcript": "Aipainret, cali-llu calriit, tuai-w' arrsaulrianek ap'laqput, cali-llu elliraat",
        "translation": "Widows, and you know, whom we call the poor, and the orphans"
    },
    "9": {
        "startTime": 56.645,
        "endTime": 64.455,
        "transcript": "Pitangqellruuq tamatum nalliini akimek aulukutailnguut",
        "translation": "Back then, there were those who had no financial care"
    },
    "10": {
        "startTime": 65.205,
        "endTime": 70.335,
        "transcript": "Welfare-anek pitaitellruami tamatum nalliini.",
        "translation": "Because there was no welfare back then."
    },
    "11": {
        "startTime": 70.475,
        "endTime": 79.025,
        "transcript": "Tau͡gaam yuut ellmeggnek ukut piyugngalriit, yuilqumek unangyugngalriit",
        "translation": "But these people who were able by the themselves, those who could catch from the wilderness"
    },
    "12": {
        "startTime": 79.025,
        "endTime": 84.76,
        "transcript": "Pingnaqellriit unangqayuluteng neqkanek quyurcilartut.",
        "translation": "Those who are good hunters gather food."
    },
    "13": {
        "startTime": 84.76,
        "endTime": 93.75,
        "transcript": "Tua-i-gguq tamaa-i tamakunun aulukestekaulria Agayutem cikiumaluku tuaten unangliqevkarluku",
        "translation": "They say that that one who is to care [for the less fortunate] is given by God to catch many things"
    },
    "14": {
        "startTime": 93.75,
        "endTime": 97.32,
        "transcript": "Tamakunun cikiutekangevkarluku.",
        "translation": "So that [s]he can give those to them."
    },
    "15": {
        "startTime": 97.41,
        "endTime": 103.89,
        "transcript": "Tua-i nutaan piuralaraakut waten imkut angayuqamta:",
        "translation": "So, our parents back then would always tell us this:"
    },
    "16": {
        "startTime": 104.005,
        "endTime": 110.425,
        "transcript": "\"Now, when you go, when you are able to provide for yourself",
        "translation": "\"Now, when you go, when you are able to provide for yourself"
    },
    "17": {
        "startTime": 111.64,
        "endTime": 120.83,
        "transcript": "\"Yugnek tuaten elpet pikangqerquvet ikayuutekangluteng unangekuvet",
        "translation": "\"For those people, if you have some, if you obtain what you can use to help"
    },
    "18": {
        "startTime": 121.75,
        "endTime": 129.42,
        "transcript": "\"Neqkailnguq neqkaanek pingnaqluku pikangqerrutacirpetun",
        "translation": "\"Give as much food as you can to one without food"
    },
    "19": {
        "startTime": 129.95,
        "endTime": 136.77,
        "transcript": "\"Aipainret, arrsaulriit, elliraat arcaqerluki.",
        "translation": "\"Especially widows, the poor, and orphans."
    },
    "20": {
        "startTime": 137.125,
        "endTime": 141.035,
        "transcript": "\"Neqkarrlainaq-llu kiingan pivkenaku.",
        "translation": "\"And not always just with food."
    },
    "21": {
        "startTime": 142.115,
        "endTime": 153.55,
        "transcript": "\"Aturarkaanek-llu pikangqerquvet, cipnengqerquvet atu'urkaanek ikayurluku pikangqerquvet.",
        "translation": "\"If you have clothes for him, if you have extra, help him with clothes to wear if you have any."
    },
    "22": {
        "startTime": 153.55,
        "endTime": 163.55,
        "transcript": "\"Tua-i tamaa-i elpet taumun ikayuutekarpenek tuaten pingqerquvet pinarqaaten.\"",
        "translation": "\"If you have anything to help that person, you must.\""
    },
    "23": {
        "startTime": 163.555,
        "endTime": 173.845,
        "transcript": "Tua-i cali waten taukut cali pilaraitkut",
        "translation": "They'd also tell us this"
    },
    "24": {
        "startTime": 173.845,
        "endTime": 176.655,
        "transcript": "Tamanarrlainaq pivkenaku",
        "translation": "Not always that"
    },
    "25": {
        "startTime": 176.655,
        "endTime": 188.725,
        "transcript": "Iliini unuakumi wiinga imum aanama tamaani ayagyuarlua pilaqiinga maktaqama",
        "translation": "Some mornings, my mother would tell me back when I was young when I got up"
    },
    "26": {
        "startTime": 189.925,
        "endTime": 198.125,
        "transcript": "\"Kitaki qakemkut yuut paqeski.",
        "translation": "\"Now, go out there and check on the people."
    },
    "27": {
        "startTime": 199.53,
        "endTime": 206.72,
        "transcript": "\"Mer'iciiqut, muraiciiqut, camek piiciiqut.",
        "translation": "\"They won't have water, won't have wood, and won't have something."
    },
    "28": {
        "startTime": 206.72,
        "endTime": 212.75,
        "transcript": "\"Ullagluki paqeski tamakut imkut, arnat-llu pistailnguut.\"",
        "translation": "\"Go and check on them, and the women with no providers.\""
    },
    "29": {
        "startTime": 212.89,
        "endTime": 219.26,
        "transcript": "Tua-i tuaten pisquciatun",
        "translation": "As she requested"
    },
    "30": {
        "startTime": 219.26,
        "endTime": 226.18,
        "transcript": "Nallunrit'laamki tamakut arnat pistailnguut-llu tuaten pinarquciat",
        "translation": "Since I knew those women and those without providers needed that"
    },
    "31": {
        "startTime": 226.185,
        "endTime": 230.255,
        "transcript": "Ellmeggnek muragtesciigalnguut, equgtarciigalnguut",
        "translation": "Those who couldn't gather wood on their own"
    },
    "32": {
        "startTime": 230.365,
        "endTime": 240.895,
        "transcript": "Ullagluki nutaan wiinga tememkun tua-i tamaa-i ikayuutekat cali neqngunrilengraan, tamaa-i muraitellra",
        "translation": "I would go to them and help them with my body even though it was food, if they didn't have wood"
    },
    "33": {
        "startTime": 240.895,
        "endTime": 244.705,
        "transcript": "Muriit-llu neqkaunitullruiceteng tamaani.",
        "translation": "Because they said wood was [to help with] a food source."
    },
    "34": {
        "startTime": 244.705,
        "endTime": 253.985,
        "transcript": "Murak-gguq neqkatun ayuquq. Tua-i-gguq neqkamek kenirciigaciiquq murailkuni.",
        "translation": "They said wood is like a food source. They said one cannot cook food without wood."
    },
    "35": {
        "startTime": 254.22,
        "endTime": 261.31,
        "transcript": "Tua-i-am tamaa-i share-allerkaqa wii tua-i waken anglicartemnek tuaten pisqellua",
        "translation": "That was how I was supposed to share as the one who raised me told me to"
    },
    "36": {
        "startTime": 261.31,
        "endTime": 268.62,
        "transcript": "\"Kitaki qakemkut paqeski, camek enuqlitellratnek ikayurniaten.",
        "translation": "\"Now, go check on the people out there, and help them with whatever they lack."
    },
    "37": {
        "startTime": 269.77,
        "endTime": 274.92,
        "transcript": "\"Cali tua-i neqkangqerquvet nallunrilkengangqerquvet",
        "translation": "\"Also, if you have food any know of anyone"
    },
    "38": {
        "startTime": 274.92,
        "endTime": 280.14,
        "transcript": "\"Kitaki neqkamek cali pingnaqkiu yuk tauna.",
        "translation": "\"Now, try to give that person food."
    },
    "39": {
        "startTime": 280.145,
        "endTime": 288.075,
        "transcript": "\"Tua-i elliin atam quyatii taum yuum elpenun angqapigtuq.\"",
        "translation": "\"You see, that person's gratitude to you is very great.\""
    },
    "40": {
        "startTime": 288.075,
        "endTime": 297.105,
        "transcript": "Atam-gguq quyatii aulukestemta Ellam Yuan cimirniaraa tauna amllenranek.",
        "translation": "Watch, they said, our caretaker, the Spirit of the Universe, will exchange his gratitude for more."
    },
    "41": {
        "startTime": 297.225,
        "endTime": 303.115,
        "transcript": "Una tua-i sharing-aaq waten pitaqerluku",
        "translation": "This is all for sharing"
    },
    "42": {
        "startTime": 303.115,
        "endTime": 313.155,
        "transcript": "Atunem ikayuutellerkaq, cikirtuutellerkaq enuqlitellra tua-i pitaciatun tangerrluku.",
        "translation": "Helping each other, and giving depending on how much one is lacking."
    },
    "43": {
        "startTime": 314.45,
        "endTime": 318.54,
        "transcript": "Waten una pitaqerluku una piaqa waten.",
        "translation": "This is all I'm saying about it."
    },
    "44": {
        "startTime": 319.67,
        "endTime": 323.33,
        "transcript": "Okay. I just wanted to...",
        "translation": "Okay. I just wanted to..."
    },
    "45": {
        "startTime": 326.735,
        "endTime": 332.41,
        "transcript": "Tua-i-w' ikayuqengyaraq man'a avaken ayagluni piulria.",
        "translation": "Well, helping out is an ancient practice."
    },
    "46": {
        "startTime": 332.41,
        "endTime": 339.07,
        "transcript": "Avani-llu au͡gkut ikayuq'ngelriit akimek tegucuyuitellruut.",
        "translation": "And people back then who helped out wouldn't want to take payments."
    },
    "47": {
        "startTime": 339.075,
        "endTime": 343.185,
        "transcript": "Akingyuunateng ikayuq'ngellruut au͡gkut ciuqliit.",
        "translation": "Our ancestors back then wouldn't take payments when helping out."
    },
    "48": {
        "startTime": 344.625,
        "endTime": 352.205,
        "transcript": "Ikayuq'ngetullruut akiliryarauvkenani.",
        "translation": "They used to help out without requiring payment."
    },
    "49": {
        "startTime": 352.205,
        "endTime": 359.835,
        "transcript": "Ilakelriit-llu tungelquqelriit quyurmeng eneni uitatullruut enemi ataucimi.",
        "translation": "And families, relatives, would live together in single houses."
    },
    "50": {
        "startTime": 359.835,
        "endTime": 363.385,
        "transcript": "Back at that time",
        "translation": "Back at that time"
    },
    "51": {
        "startTime": 363.925,
        "endTime": 376.3,
        "transcript": "Ilakelriit, tungelquqelriit enemi ataucimi, enerpall'e'rmi marayami enemi muragnek aklulegmi tua-i uitaaqluteng.",
        "translation": "Families, relatives, in one house, would live in one huge sod house with wooden accouterments."
    },
    "52": {
        "startTime": 376.3,
        "endTime": 387.29,
        "transcript": "Ikegkuk pikani yuungnaqelriik, ukuk-ll' irnialget, tua-i tuaten cetamauluteng enem iluani uitatullrulliniut.",
        "translation": "Across there were those who subsisted, and here those with children, four families would live like that in the house."
    },
    "53": {
        "startTime": 387.29,
        "endTime": 397.12,
        "transcript": "Wiinga-llu ellma angucuayaallruaqa tamana tuaten uitalallrat enepigni marayani tungayakelriit.",
        "translation": "I was also born at the cusp of that, when relatives lived in traditional sod houses like that."
    },
    "54": {
        "startTime": 397.94,
        "endTime": 402.42,
        "transcript": "Tungelququtellruut, kenkutellruut au͡gkut yuut.",
        "translation": "People back then had good relations, loved each other."
    },
    "55": {
        "startTime": 403.705,
        "endTime": 410.055,
        "transcript": "Waniwa-llu tua-i wiinga ciulianka Qinarmiunguyaaqut.",
        "translation": "And now, my ancestors are actually from Qinaq."
    },
    "56": {
        "startTime": 410.055,
        "endTime": 415.89,
        "transcript": "Imum unuaq au͡g'um nangerrluni qalartellriim Qinarmium nunalgutkaanga",
        "translation": "That one from Qinaq who stood up this morning and spoke is from the same village as I am"
    },
    "57": {
        "startTime": 415.89,
        "endTime": 422.86,
        "transcript": "Imum wani au͡g'um tan'gaurluum ciuqlikacaarmek ikirutestellemta.",
        "translation": "That boy who was the very first to open up our gathering."
    },
    "58": {
        "startTime": 422.86,
        "endTime": 427.25,
        "transcript": "Ciulianka, angayuqaagka Qinarmiungullruuk.",
        "translation": "My ancestors, my parents were from Qinaq."
    },
    "59": {
        "startTime": 427.25,
        "endTime": 435.0,
        "transcript": "Tamaa-i tamaani ellangartellemni ataucimek Kass'angqellruut taukut nunat.",
        "translation": "Back in my earliest memories, that village had one resident Caucasian."
    },
    "60": {
        "startTime": 436.3,
        "endTime": 446.91,
        "transcript": "Ellangartellruunga nunanek taukunek, kuigem au͡g'um akiqliqluteng nunauluteng.",
        "translation": "That village was my earliest memories, a village where they lived across the river from each other over there."
    },
    "61": {
        "startTime": 446.91,
        "endTime": 452.32,
        "transcript": "Taumek Kass'amek ataucimek Kass'angqellrulliniut taukut nunat.",
        "translation": "That village apparently had that one resident Caucasian."
    },
    "62": {
        "startTime": 453.07,
        "endTime": 460.76,
        "transcript": "Tua-i arenqiatuq ikayuqengyaraq au͡gna maa-i mat'um nalliini tua-i-am atunrirtuq.",
        "translation": "It's unfortunate that helping out these days is no longer practiced."
    },
    "63": {
        "startTime": 461.55,
        "endTime": 470.38,
        "transcript": "Makut arrliurciigaliit. Piyugngang'e'rmeng ayagyuat makut wani ellmeggnek pisciigaliut.",
        "translation": "They can't prepare for guests anymore. Though young people are able, they can't do them on their own anymore."
    },
    "64": {
        "startTime": 470.38,
        "endTime": 475.03,
        "transcript": "Akiinateng-llu, akirraunateng piqerciigaliluteng.",
        "translation": "And without payment, they can't do it without a little payment."
    },
    "65": {
        "startTime": 475.03,
        "endTime": 480.18,
        "transcript": "Avani tamakut yuut kenka atullrulliniat.",
        "translation": "Back then, those people evidently practiced love."
    },
    "66": {
        "startTime": 483.82,
        "endTime": 494.45,
        "transcript": "Neqsurciigalnguut-llu, yuurqerciigalnguut-llu Kass'artarmek caliyuilnguut",
        "translation": "And those who couldn't fish, and the unemployed who couldn't drink Western tea"
    },
    "67": {
        "startTime": 495.75,
        "endTime": 501.83,
        "transcript": "Uksurpak nerumavkalallruit cikiutet yugnek.",
        "translation": "All winter, they'd eat of people's gifts."
    },
    "68": {
        "startTime": 501.835,
        "endTime": 505.415,
        "transcript": "Wiinga-llu ellangellruunga tua-i.",
        "translation": "I also had my earliest memories."
    },
    "69": {
        "startTime": 505.91,
        "endTime": 512.61,
        "transcript": "Mikcuaraulua ataka catairutellrani ellangartellruunga.",
        "translation": "I have early memories when my father passed away when I was very small."
    },
    "70": {
        "startTime": 513.24,
        "endTime": 517.67,
        "transcript": "Tamaa-i-llu tua-i kinguani",
        "translation": "And after that back then"
    },
    "71": {
        "startTime": 518.59,
        "endTime": 524.41,
        "transcript": "Tuaken tua-i ellangeqarraararvillemnek",
        "translation": "From there where my earliest memories were"
    },
    "72": {
        "startTime": 524.885,
        "endTime": 536.46,
        "transcript": "Wavet Elumarvigmun anaanama uingan itrautellruitkut.",
        "translation": "My maternal aunt's husband brought us upriver to Lomavik."
    },
    "73": {
        "startTime": 536.46,
        "endTime": 547.27,
        "transcript": "Tamaa-i cali uani Elumarvigmi cali uitallruunga ellangvimnun, nutaan-llu tuaken ellaka nalluyagutenqigtevkenaku.",
        "translation": "I also stayed there downriver at Lomavik until I became aware, and from then on, I have always been aware."
    },
    "74": {
        "startTime": 548.61,
        "endTime": 556.41,
        "transcript": "Yuut aulukellruitkuk. Aanaka castauanani.",
        "translation": "People took care of us. My mother had no provider."
    },
    "75": {
        "startTime": 556.415,
        "endTime": 562.435,
        "transcript": "Cikiutet quyanarqellruut caknerpak.",
        "translation": "Gifts were a cause for great thanks."
    },
    "76": {
        "startTime": 562.72,
        "endTime": 571.65,
        "transcript": "Neqkat, aturarkat-llu, aturarkat-wa tua-i tamaa-i qaim mat'um patukai",
        "translation": "Food, and clothing, clothing that covers this body"
    },
    "77": {
        "startTime": 571.65,
        "endTime": 578.33,
        "transcript": "Yugnek cikiutet angqapiarallruut wangni umyuamni, umyuamnun.",
        "translation": "People's gifts were very great to me, in my opinion."
    },
    "78": {
        "startTime": 578.335,
        "endTime": 581.805,
        "transcript": "Quyanaqpiarluteng caknerpak.",
        "translation": "I am extremely thankful for them."
    },
    "79": {
        "startTime": 582.17,
        "endTime": 592.66,
        "transcript": "Atalegnek, ilalegnek, ilalilrianek ayuqniatullruunga, anelgut'lilrianek.",
        "translation": "I would covet those with fathers, families, large familes, many siblings."
    },
    "80": {
        "startTime": 594.46,
        "endTime": 605.05,
        "transcript": "Tamaa-i yuut ikayuq'ngellrata, aulukellrata, ikayuutellrata",
        "translation": "People's helping out, taking care of others, helping others"
    },
    "81": {
        "startTime": 605.1,
        "endTime": 615.41,
        "transcript": "Waten wiinga tua-i maa-i mat'um nalliini qanerkangqercetaatnga yuut tamakut ciuqliit ikayuq'ngellret.",
        "translation": "Those people back then who helped out gave me this to say right now."
    },
    "82": {
        "startTime": 615.75,
        "endTime": 619.17,
        "transcript": "Quyanaqpiarluteng caknerpak.",
        "translation": "I am very thankful for them."
    },
    "83": {
        "startTime": 619.48,
        "endTime": 626.81,
        "transcript": "Maa-i tang mat'um nalliini iciwa qanlalriaci yuut ayuquciat cimirniluku?",
        "translation": "You see, these days, you know how you say that people have changed?"
    },
    "84": {
        "startTime": 626.81,
        "endTime": 630.54,
        "transcript": "Cimiutai nallunritaput.",
        "translation": "We know how they've changed."
    },
    "85": {
        "startTime": 630.54,
        "endTime": 635.08,
        "transcript": "Tungelquqelriit, tungayakelriit tungayakutenrirtut.",
        "translation": "Families, close relatives do not act like relatives anymore."
    },
    "86": {
        "startTime": 635.085,
        "endTime": 639.78,
        "transcript": "Ilaita-llu tungayateng, aanameng-llu ilait nalluaqluki.",
        "translation": "And some don't know their relatives, or their mothers' relatives."
    },
    "87": {
        "startTime": 639.78,
        "endTime": 644.24,
        "transcript": "Atameng-llu tungayait nalluaqluki mat'um nalliini.",
        "translation": "And they don't know their fathers' relatives these days."
    },
    "88": {
        "startTime": 644.245,
        "endTime": 650.795,
        "transcript": "Maa-i-w' tua-i cimian tamana yuut kenkutellrat.",
        "translation": "It's because people's treating each other with love has changed now."
    },
    "89": {
        "startTime": 651.585,
        "endTime": 660.8,
        "transcript": "Tua-llu aptaqama tamaani kinguani, \"Qaillun taukut enem iluanelnguut yuullruat?\"",
        "translation": "Then when I asked after that time, \"How did those in the home live?\""
    },
    "90": {
        "startTime": 660.8,
        "endTime": 663.57,
        "transcript": "Taum aanama qanrutaqlua waten:",
        "translation": "My mother would tell me this:"
    },
    "91": {
        "startTime": 663.57,
        "endTime": 666.92,
        "transcript": "Yuut-gguq taukut yuullruut",
        "translation": "Those people lived"
    },
    "92": {
        "startTime": 668.37,
        "endTime": 679.26,
        "transcript": "Una piutengqerpek'nani, una-llu neqautminek qanyuunani, nangqatalrianek nangelrianek-llu qanyuunani.",
        "translation": "This didn't claim anything, and this didn't speak of their food, and they didn't say they're low or gone."
    },
    "93": {
        "startTime": 679.26,
        "endTime": 685.78,
        "transcript": "Ilakuyutqapiarluteng ilakuyutellriit ataucimek enerluteng.",
        "translation": "Very tight-knit relatives had one house."
    },
    "94": {
        "startTime": 686.985,
        "endTime": 690.515,
        "transcript": "Kina-llu qunuyuunani.",
        "translation": "And no one was stingy."
    },
    "95": {
        "startTime": 690.995,
        "endTime": 697.725,
        "transcript": "Tua-i-gguq tamakut tungelququtellriit ilateng ikayuapiatullruit cakneq.",
        "translation": "She said those families helped their relatives a lot."
    },
    "96": {
        "startTime": 697.725,
        "endTime": 706.66,
        "transcript": "Camek-llu qunucuunaki. Kiingan-llu pik'nge'rmegteggu tua-i taumun, taumun aturcetaqluku akiinaku.",
        "translation": "And they never refused them anything. Even if it was their only one, they'd have them use it without payment."
    },
    "97": {
        "startTime": 706.66,
        "endTime": 713.06,
        "transcript": "Maa-i tang mat'um nalliini ca tamarmi carraquinrayagaq",
        "translation": "You see, these days, every little thing"
    },
    "98": {
        "startTime": 713.515,
        "endTime": 722.055,
        "transcript": "Akiyuutngurtellria ikayuutekaq, cikiutekaq.",
        "translation": "What was to be for help, to be given, has turned profitable."
    },
    "99": {
        "startTime": 722.7,
        "endTime": 726.62,
        "transcript": "Cali alerquutengqerrluta wangkuta.",
        "translation": "We also had a traditional instruction."
    },
    "100": {
        "startTime": 729.015,
        "endTime": 736.325,
        "transcript": "Arnaungramta, arnarraungramta, camek-llu kipulluta pisciigalengramta",
        "translation": "Though we're women, just women, and can't buy anything"
    },
    "101": {
        "startTime": 736.325,
        "endTime": 739.88,
        "transcript": "Ikayuqengyugnganiluta yugnek.",
        "translation": "That we can help people out."
    },
    "102": {
        "startTime": 739.88,
        "endTime": 747.74,
        "transcript": "Umyuartequa tuani waten mat'umek niitellemni: \"Wii-kiq ca aturluku ikayuqengniarcia?\"",
        "translation": "I thought like this back when I heard this: \"I wonder what I can use to help out?\""
    },
    "103": {
        "startTime": 747.745,
        "endTime": 750.945,
        "transcript": "Taum waten aanama pianga:",
        "translation": "My mother said this to me:"
    },
    "104": {
        "startTime": 751.24,
        "endTime": 759.53,
        "transcript": "\"Camek qanruskuvgu nanikualria, assilriamek qanruskuvgu ikayurciqan.\"",
        "translation": "\"If you say something to a depressed person, if you say something good, you will help them.\""
    },
    "105": {
        "startTime": 759.53,
        "endTime": 762.65,
        "transcript": "Tua-llu waten pianga cali:",
        "translation": "Then she also said this to me:"
    },
    "106": {
        "startTime": 762.655,
        "endTime": 769.39,
        "transcript": "\"Qainga allgulria, allganlilria mingqestailnguq",
        "translation": "\"His tattered clothes with many holes without anyone to sew it"
    },
    "107": {
        "startTime": 769.39,
        "endTime": 777.01,
        "transcript": "\"Natii imna allganruarii-llu nunguareskuvgu tauna ikayurarkaugan.\"",
        "translation": "\"If you sew the tears closed, you shall help him.\""
    },
    "108": {
        "startTime": 777.015,
        "endTime": 787.585,
        "transcript": "Tamaa-i ikayuutekelput au͡gkunek avani tua-i yuullemteńi wangkuta akimek ikayuutekaunata.",
        "translation": "Those were how we helped others back in our lives without money to help others."
    },
    "109": {
        "startTime": 787.585,
        "endTime": 790.495,
        "transcript": "Ikayuutektullruaput tua-i",
        "translation": "That's how we helped"
    },
    "110": {
        "startTime": 790.495,
        "endTime": 798.265,
        "transcript": "Atulallruamku-llu wii man'a nunguarcilalqa makunek.",
        "translation": "And because I used to practice mending these clothes."
    },
    "111": {
        "startTime": 798.265,
        "endTime": 803.655,
        "transcript": "Atam cali elitengqertuq kia imum ayagniquniu man'a.",
        "translation": "You see, it also becomes a habit if anyone starts this."
    },
    "112": {
        "startTime": 803.915,
        "endTime": 811.41,
        "transcript": "Maani-llu allgulriamek tangerquni, tua-i-ll' umyuaqerrluku, \"Waniwa-tuq una kitugglaku.\"",
        "translation": "And if they see something torn here, they'll remember it, \"Let me fix this now.\""
    },
    "113": {
        "startTime": 811.41,
        "endTime": 816.69,
        "transcript": "Tuaten elitnarquq. Ca tamarmi elitengqertuq.",
        "translation": "One can learn like that. Anything can become a habit."
    },
    "114": {
        "startTime": 816.695,
        "endTime": 821.25,
        "transcript": "Tamana tuaten atullemni elitellruaqa.",
        "translation": "When I practiced that, it became my habit."
    },
    "115": {
        "startTime": 821.25,
        "endTime": 828.29,
        "transcript": "Tua-i Kassaungraata-llu makuungraata tangrraqamki piyugyaaqnaunka.",
        "translation": "Even if they're these Caucasians, when I see them, I want to [mend] them."
    },
    "116": {
        "startTime": 828.295,
        "endTime": 833.165,
        "transcript": "Nungucugyaaqluku-llu tauna allganeq umyuarteqaqlua.",
        "translation": "And I would think that I want to mend that tear closed."
    },
    "117": {
        "startTime": 833.165,
        "endTime": 837.555,
        "transcript": "Tua-i-wa ca tamarmi elitengqerrami.",
        "translation": "It's because anything can become a habit."
    },
    "118": {
        "startTime": 838.465,
        "endTime": 843.015,
        "transcript": "Ikayuqengyaraq, yuum ikayuutekaa amllertuq.",
        "translation": "In helping out, there are many ways to help a person."
    },
    "119": {
        "startTime": 855.115,
        "endTime": 864.685,
        "transcript": "Amlleq ikayurtaagutlerkaq neqkatgun ava-i tua-i ilii taringekvut",
        "translation": "We've understood part of the many ways to help others through food"
    },
    "120": {
        "startTime": 865.225,
        "endTime": 872.955,
        "transcript": "Avani ikuyrtaagutetullruamta wangkuta nallemteńi cikirtaagulluta.",
        "translation": "Because we helped each other back in our time by giving to each other."
    },
    "121": {
        "startTime": 872.955,
        "endTime": 883.11,
        "transcript": "Neqkamek-llu up'nerkami enuqliterpalaameng ilait unangyuilnguut, neqsuyuilnguut, pisciigalnguut",
        "translation": "And since some who do not catch anything, fish, or are unable have great shortages of food in the spring"
    },
    "122": {
        "startTime": 883.11,
        "endTime": 892.54,
        "transcript": "Tamaaggun tua-i kanaulaamteki maavet neq'ngellerkaanun.",
        "translation": "Since through that, we carry them through food scarcity until food comes."
    },
    "123": {
        "startTime": 892.86,
        "endTime": 903.49,
        "transcript": "Tau͡gaam una waniw' nugtarrvikluku piqataraput: atunem ikayurtaagutlerkaq.",
        "translation": "But we're going to move on to this: helping each other."
    },
    "124": {
        "startTime": 904.89,
        "endTime": 912.49,
        "transcript": "Atunem ikayurtaagutlerkaq pillgutekluni.",
        "translation": "Helping each other as a community."
    },
    "125": {
        "startTime": 912.495,
        "endTime": 922.885,
        "transcript": "Camek wangkuta ikayurtaagulluta, wall' nunalegni cat ilaitni atutuarput tamana.",
        "translation": "Helping each other with something, or sometimes, we practice that in villages."
    },
    "126": {
        "startTime": 924.235,
        "endTime": 931.645,
        "transcript": "Camek ilavut tua-i carpagmek iliini caliangqelartuq",
        "translation": "Sometimes, one of us has a some big job to do"
    },
    "127": {
        "startTime": 931.645,
        "endTime": 935.895,
        "transcript": "Wall'u enelingnaqluni-llu",
        "translation": "Or trying to build a house"
    },
    "128": {
        "startTime": 936.425,
        "endTime": 944.135,
        "transcript": "Wall'u muragnek tamaani enengqetuameng, tuskanek piyuitellruameng tamatum nalliini",
        "translation": "Or because they had wooden homes back then, since they didn't have wooden boards at that time"
    },
    "129": {
        "startTime": 944.135,
        "endTime": 949.175,
        "transcript": "Makunek plywood-aat-llu cataitellruameng tamatum nalliini.",
        "translation": "Also because there were none of this plywood back then."
    },
    "130": {
        "startTime": 949.455,
        "endTime": 958.065,
        "transcript": "Tau͡gaam muragnek enekarrluteng yuut maani Kusquqvagmi pitullruameng",
        "translation": "But since people would get wood for houses from here on the Kuskokwim"
    },
    "131": {
        "startTime": 958.315,
        "endTime": 963.165,
        "transcript": "Tamakunek atussiyaanringameng.",
        "translation": "Since they don't use those much anymore."
    },
    "132": {
        "startTime": 963.165,
        "endTime": 969.995,
        "transcript": "Cali nallemni atuqaqulang'e'rmegteki mudhouse-at au͡gkut apqait",
        "translation": "Also, though they regularly used what they called mudhouses in my time"
    },
    "133": {
        "startTime": 969.995,
        "endTime": 978.105,
        "transcript": "Tamatum nalliini atutullruamegteki up'nerkillerni-llu, kiillerni, uksuillerni-llu",
        "translation": "Since they used those at that time in spring camps, fish camps, and winter camps"
    },
    "134": {
        "startTime": 978.105,
        "endTime": 981.12,
        "transcript": "Tua-i tamakut atuumamallrukait.",
        "translation": "Thye used those for a long time."
    },
    "135": {
        "startTime": 981.12,
        "endTime": 991.63,
        "transcript": "Tau͡gaam nunani waten ukut nunarraat camek caliaqata ikayungcarilartut caperqelaamegteki",
        "translation": "But in small villages like this, they ask for help when they work on something because they find them difficult"
    },
    "136": {
        "startTime": 991.63,
        "endTime": 999.94,
        "transcript": "Muriit-llu makut uqiggetenrilameng, canek-llu cayugcuutnek piitellruamta tamatum nalliini",
        "translation": "And since wood is not light, and we had no machines to pull them back then"
    },
    "137": {
        "startTime": 1000.18,
        "endTime": 1005.3,
        "transcript": "Tau͡gaam tua-i unatetgun tegularluki pitullruameng.",
        "translation": "But, because they took them by hand."
    },
    "138": {
        "startTime": 1006.41,
        "endTime": 1013.38,
        "transcript": "Cali tua-i qanruyutelaameng",
        "translation": "Also, since they spoke to each other"
    },
    "139": {
        "startTime": 1013.41,
        "endTime": 1023.07,
        "transcript": "Elpengevkalaitkut, ilateng elpengevkarluki uumek ikayurnarqellriamek piaqameng.",
        "translation": "They notify us, they notify those around them when they work on this that needs help."
    },
    "140": {
        "startTime": 1023.715,
        "endTime": 1033.99,
        "transcript": "Tua-i-llu nutaan imkut yuut taukuni nunarrarni uitalriit kitakiilaraitkut",
        "translation": "Then the people of that village prod us"
    },
    "141": {
        "startTime": 1033.99,
        "endTime": 1043.13,
        "transcript": "Camek pirpanrilngurmek ikayuutarkaunrilengramta ullautesqelluta.",
        "translation": "That even if it's not big and we won't have to help, to go to them."
    },
    "142": {
        "startTime": 1044.435,
        "endTime": 1051.33,
        "transcript": "Tua-i ellait taqneret ellaita calillgutekluteng piaqata",
        "translation": "When those adults worked together"
    },
    "143": {
        "startTime": 1051.33,
        "endTime": 1056.94,
        "transcript": "Camek ellimeraqatkut wangkuta tua-i ca im' pirpanrilnguq aqvaaqluku.",
        "translation": "When they ordered us, we'd get something though it wasn't important."
    },
    "144": {
        "startTime": 1056.94,
        "endTime": 1064.1,
        "transcript": "Calissuun-llu ca-llu imna ellimerutekaqatgu aqvaaqluku tua-i wangkuta.",
        "translation": "And when they asked for a tool or something, we'd get it."
    },
    "145": {
        "startTime": 1064.105,
        "endTime": 1072.62,
        "transcript": "Tua-i tallikelriacetun tamakut taqneret makut camek caliaqameng.",
        "translation": "We were like the arms for these adults when they worked on something."
    },
    "146": {
        "startTime": 1072.62,
        "endTime": 1084.68,
        "transcript": "Enemek-llu eneliqatarqameng tagutelaamegteki piavet tua-i caliaqvigkaan nuniinun maaken mermek tagulluku.",
        "translation": "And when they were going to make houses, since they brought them inland to where it's going to be worked on, they'd bring them up from the water here."
    },
    "147": {
        "startTime": 1084.965,
        "endTime": 1092.985,
        "transcript": "Wall'u cali imumi-am",
        "translation": "Or also, a long time ago"
    },
    "148": {
        "startTime": 1094.24,
        "endTime": 1100.28,
        "transcript": "Nunalget ukut mat'umek-am ikayungcaritullrulriit.",
        "translation": "These villages would ask for help with this."
    },
    "149": {
        "startTime": 1101.045,
        "endTime": 1109.18,
        "transcript": "Qasgimek-ll' uumek caliqata'arqameng qasgim caliaqsaraa angengami",
        "translation": "And when they were going to build a community house, since making a community house is a big job"
    },
    "150": {
        "startTime": 1109.18,
        "endTime": 1113.43,
        "transcript": "Muragpall'e'rnek-llu piyaraullruami canirtarnek.",
        "translation": "And since it needed huge logs of wood."
    },
    "151": {
        "startTime": 1113.43,
        "endTime": 1119.56,
        "transcript": "Nunalget kelegluki invite-arluki pitullruit.",
        "translation": "They'd invite, kelegluki, villages."
    },
    "152": {
        "startTime": 1119.56,
        "endTime": 1129.2,
        "transcript": "Ellaita ukut yuut yugkarteng ikgellekluki piaqamegteki nunalget kelelarait, invite-arluki nunameggnun.",
        "translation": "When they thought their people would be to few, they'd invite villages to their own."
    },
    "153": {
        "startTime": 1129.205,
        "endTime": 1137.505,
        "transcript": "Aperluku qasgimek caliqatarniluteng, ikayuusqelluteng.",
        "translation": "They say that they were going to work on a community house, and asked for help."
    },
    "154": {
        "startTime": 1137.9,
        "endTime": 1147.61,
        "transcript": "Tua-i-ll' taukut nunalget invite-allrit nunanek tua-i tekilluteng tua-i, nutaan tua-i tekilluteng taum kelgumiimeng.",
        "translation": "Then those villages that they invited would arrive, they would arrive there since they were invited."
    },
    "155": {
        "startTime": 1148.23,
        "endTime": 1153.21,
        "transcript": "Ak'a tua-i muriit tau͡gaam upingaluteng tua-i kana-i pikait.",
        "translation": "But the wood they were going to use was already ready down there."
    },
    "156": {
        "startTime": 1154.765,
        "endTime": 1164.915,
        "transcript": "Nutaan tua-i qavcin nunat, malruin-llu kelellrit tua-i calillgutekluteng caliluteng ikayuqluteng.",
        "translation": "Then several villages, even two they invited, would work together and help each other."
    },
    "157": {
        "startTime": 1165.195,
        "endTime": 1172.505,
        "transcript": "Tauna enerpall'er qasgiq caliaqluku ikayuqluteng.",
        "translation": "They'd help each other work on that huge sod house, the community house."
    },
    "158": {
        "startTime": 1172.965,
        "endTime": 1177.815,
        "transcript": "Marayamek-llu patulaamegteki tamaani qasgit",
        "translation": "And since they covered community houses with sod back then"
    },
    "159": {
        "startTime": 1178.08,
        "endTime": 1188.75,
        "transcript": "Makunek tua-i canegnek-llu kanevyailkucirraarluki nutaan marayamek patulaamegteki",
        "translation": "And since they covered them in sod after they spread grass to prevent crumbling down"
    },
    "160": {
        "startTime": 1188.75,
        "endTime": 1193.93,
        "transcript": "Muriit tamakut canirtaarteng taqumariaqata.",
        "translation": "When they finished setting the logs on their sides."
    },
    "161": {
        "startTime": 1194.295,
        "endTime": 1204.245,
        "transcript": "Tua-i-am tuaten nutaan tauna caliaqluku taqvianun.",
        "translation": "They would work on it like that until it was finished."
    },
    "162": {
        "startTime": 1204.465,
        "endTime": 1217.675,
        "transcript": "Tua-i tau͡gaam taqngan nutaan imkut invite-alteng nunanek ukut nunalget nutaan maa-i nallemteńi ap'laqput potluck-aarluteng.",
        "translation": "When they were finished, this host village would hold what we call today a potluck for the villages they invited."
    },
    "163": {
        "startTime": 1217.905,
        "endTime": 1226.86,
        "transcript": "Tua-i tamatum nalliini nutaan tua-i nerevkarluki kassiyucuarluteng tauna imna taqngan qasgiq.",
        "translation": "Back then, they'd hold a feast like a small dance festival when that community house was finished."
    },
    "164": {
        "startTime": 1226.86,
        "endTime": 1235.78,
        "transcript": "Aren nutaan tua-i yurarluteng tuaten tamatumek tua-i nutaan akililriacetun piluki.",
        "translation": "Oh my, they would even Yup'ik dance like a reward for that to them."
    },
    "165": {
        "startTime": 1235.785,
        "endTime": 1238.16,
        "transcript": "Angniutekaatnek pivkarluki.",
        "translation": "They had them enjoy themselves."
    },
    "166": {
        "startTime": 1238.16,
        "endTime": 1244.06,
        "transcript": "Nerevkarirraarluteng-llu tamana taqngan tuaten nutaan",
        "translation": "And after they had a feast, when that was finished"
    },
    "167": {
        "startTime": 1244.065,
        "endTime": 1248.275,
        "transcript": "Tamatumek nangnirluku nerevkaritmek.",
        "translation": "They would end with that feast."
    },
    "168": {
        "startTime": 1248.275,
        "endTime": 1254.585,
        "transcript": "Tua-i potluck-aarluteng, nutaan angnirluteng tua-i, yurarluteng tuaten.",
        "translation": "They had a potluck, and were very happy, even Yup'ik dancing."
    },
    "169": {
        "startTime": 1254.585,
        "endTime": 1260.225,
        "transcript": "Tua-i cooperation tua-i piluki, ikayuulluteng atunem.",
        "translation": "They cooperated with them, helping each other out."
    },
    "170": {
        "startTime": 1260.44,
        "endTime": 1269.67,
        "transcript": "Tua-i tuacetun-llu yuum ataucim caliarkaa cali tua-i ikayurtaagulluteng atunem pitullruameng",
        "translation": "And like that with what one person was going to make, because they helped each other"
    },
    "171": {
        "startTime": 1269.67,
        "endTime": 1278.91,
        "transcript": "Tuaten tauna ca imna piqataqiit yuum ataucim pia tauna ikayurluku.",
        "translation": "With what they were going to do, they helped with that one person's project."
    },
    "172": {
        "startTime": 1279.025,
        "endTime": 1288.575,
        "transcript": "Ellimaaluta tuaten wangkuta ikayuulluta tuaten ellaitni nayurluki pisqelluki.",
        "translation": "They'd even tell us to help out and stay among them."
    },
    "173": {
        "startTime": 1288.795,
        "endTime": 1299.125,
        "transcript": "Tua-i cali camek ukut nunat cali-am yuk tauna atauciq pinrilnge'rmegteggu",
        "translation": "And those villages, even if they weren't helped that one person"
    },
    "174": {
        "startTime": 1299.805,
        "endTime": 1310.975,
        "transcript": "Ikayuutellerkarteng-am cali ca igvartaqamegteggu qaillun piyugluteng nunat ukut",
        "translation": "With their ways of helping, when this village brought up something that they wanted to do"
    },
    "175": {
        "startTime": 1310.975,
        "endTime": 1319.765,
        "transcript": "Qanlartut imumi kanani nunangqellemteńi unani",
        "translation": "They said long ago when there were settlements down there"
    },
    "176": {
        "startTime": 1320.365,
        "endTime": 1323.735,
        "transcript": "Nunat-ll' amllenrilameng",
        "translation": "And since there weren't many villages"
    },
    "177": {
        "startTime": 1323.925,
        "endTime": 1334.145,
        "transcript": "Ukut Moravian mission-aat ayagniqarraallrata kinguani nutaan-am yuut ikayuqluteng.",
        "translation": "After the Moravion missions first started, the people really worked together."
    },
    "178": {
        "startTime": 1334.19,
        "endTime": 1337.97,
        "transcript": "Ukut wani mission-aat tuskalingarrluteng.",
        "translation": "These missions got a lot of wooden board [houses]."
    },
    "179": {
        "startTime": 1338.275,
        "endTime": 1347.565,
        "transcript": "Nutaan-am tua-i mission-aanek waten ayagluta tumyariluta qamavet kipusvigpagmun-gguq taumun.",
        "translation": "So, we made boardwalks going from the mission to what they called that big store upriver."
    },
    "180": {
        "startTime": 1350.155,
        "endTime": 1354.605,
        "transcript": "Yuut imkut akingellerkameggnek pivkena[teng].",
        "translation": "People back then didn't do it to get payment."
    },
    "181": {
        "startTime": 1360.655,
        "endTime": 1366.41,
        "transcript": "Arnat makut mat'umek mikelngurmek kenkiyaramek",
        "translation": "Women [know] about how to love children"
    },
    "182": {
        "startTime": 1366.41,
        "endTime": 1375.04,
        "transcript": "Arcaqerluteng mikelnguuluki-llu aulukituameng waken tua-i yuurtellratnek ayagluki.",
        "translation": "Especially because they take care of them as children starting from when they're born."
    },
    "183": {
        "startTime": 1375.23,
        "endTime": 1387.58,
        "transcript": "Taumek ilii tua-i nallunritlermikun Lucy-m makunek mikelngurnek kenkiyaramek",
        "translation": "That's why, with some of what Lucy knows about how to love children"
    },
    "184": {
        "startTime": 1387.58,
        "endTime": 1398.0,
        "transcript": "Nallunritellni aturluku elliin ellminek umyuarteqlermikun qanruciiqaakut.",
        "translation": "Using what she knows, she will tell us what she thinks."
    },
    "185": {
        "startTime": 1399.245,
        "endTime": 1406.585,
        "transcript": "Makut tua-i nallunritlerpekun mikelnguut, mikelngurnek kenkiyaramek",
        "translation": "Using what you know about loving children"
    },
    "186": {
        "startTime": 1406.71,
        "endTime": 1417.28,
        "transcript": "Tua-i arnanun makut yuurtellratnek ayagluki pitukait aulukaqamegteki yuurtellratnek ayagluki.",
        "translation": "Women care for them from when they're born when they care for them when they're born."
    },
    "187": {
        "startTime": 1417.4,
        "endTime": 1424.55,
        "transcript": "Kenkut'seng mikelngurnun tua-i qanrutkeqerniaran nallunritetacirpegun.",
        "translation": "Talk about how much you know about their love for children."
    },
    "188": {
        "startTime": 1433.75,
        "endTime": 1436.63,
        "transcript": "Mikelngurnek-wa tua-i imumi",
        "translation": "About children long ago"
    },
    "189": {
        "startTime": 1436.635,
        "endTime": 1444.545,
        "transcript": "Au͡gkut aulukestemta aulukellruit ca tamalkuan qanrutekluku.",
        "translation": "Our caretakers back then took care of us, giving instruction about everything."
    },
    "190": {
        "startTime": 1445.595,
        "endTime": 1453.53,
        "transcript": "Aipangllemteńek ayagluta qalaruquratullruitkut ca nalluvkarpek'naku.",
        "translation": "Starting from when we married, they'd always instruct us so we wouldn't be ignorant of anything."
    },
    "191": {
        "startTime": 1453.53,
        "endTime": 1461.94,
        "transcript": "Tuaten-llu irniangekumta aulukillerkamteńek mikelngurnek qanrutetullruitkut.",
        "translation": "And when we had children, they'd instruct us on how to care for children."
    },
    "192": {
        "startTime": 1461.94,
        "endTime": 1470.0,
        "transcript": "Au͡gkut tang aulukesteput waten ayuqellrunrilnguut watuam nalliicetun.",
        "translation": "Our caretakers back then, you see, were not like how they are now."
    },
    "193": {
        "startTime": 1470.525,
        "endTime": 1477.1,
        "transcript": "Kass'anek tangyuitellruukut amllernek, canek-llu akimek tangyuunata.",
        "translation": "We didn't see many Caucasians, and we didn't see any money."
    },
    "194": {
        "startTime": 1477.1,
        "endTime": 1481.28,
        "transcript": "Akimek tangerrnaciarumallruunga wiinga ak'anun.",
        "translation": "I didn't first see money for a long time."
    },
    "195": {
        "startTime": 1481.285,
        "endTime": 1491.435,
        "transcript": "Tua-i-wa enuqitellriarulua anglillruama tua-i tamakunek canek piyuitellrulrianga.",
        "translation": "Because I grew up in scarcity, I woulnd't get those things."
    },
    "196": {
        "startTime": 1491.435,
        "endTime": 1498.61,
        "transcript": "Cali aanama aulukillra wangnek maa-i nalluyagucuitaqa.",
        "translation": "Also, I do not forget how my mother took care of me."
    },
    "197": {
        "startTime": 1498.61,
        "endTime": 1501.3,
        "transcript": "Umyuaqelaraqa cakneq.",
        "translation": "I clearly remember it."
    },
    "198": {
        "startTime": 1502.25,
        "endTime": 1506.01,
        "transcript": "Waten aulukellruanga aanama:",
        "translation": "This is how my mother took care of me:"
    },
    "199": {
        "startTime": 1506.745,
        "endTime": 1514.635,
        "transcript": "Neqkaq man'a, neqkaq-llu man'a, meq-llu man'a anglanitekevkallrunritaa.",
        "translation": "This food, she didn't let me squander food and water."
    },
    "200": {
        "startTime": 1514.635,
        "endTime": 1519.23,
        "transcript": "Tau͡gaam elliin cikiutni kiingan tua-i.",
        "translation": "Instead, all she gave me [was all I ingested]."
    },
    "201": {
        "startTime": 1519.23,
        "endTime": 1523.11,
        "transcript": "Una wani atam tua-i iluka elisngauq waniwa.",
        "translation": "You see, my stomach is used to it now."
    },
    "202": {
        "startTime": 1523.115,
        "endTime": 1525.985,
        "transcript": "Ayuqucimnek qanrutqataramci.",
        "translation": "I'm going to tell you what I'm like."
    },
    "203": {
        "startTime": 1525.985,
        "endTime": 1533.205,
        "transcript": "Qam'um iluma elisngaa avaken ayaglua neryaraqa.",
        "translation": "My stomach is used to my eating habits since long ago."
    },
    "204": {
        "startTime": 1533.45,
        "endTime": 1542.39,
        "transcript": "Nurrluku, una wani erenrem qukallra nurrluku imirngaunaku man'a call' man'a erneq tekilluku waniw'.",
        "translation": "Before noon, I will not fill it to this day."
    },
    "205": {
        "startTime": 1542.395,
        "endTime": 1547.185,
        "transcript": "Atakutallerkaq-llu nurrluku cali imirngaunaku qamna.",
        "translation": "Neither do I fill it before dinner."
    },
    "206": {
        "startTime": 1547.185,
        "endTime": 1552.0,
        "transcript": "Tua-i elisngaluni cailkakun neramliyuunii.",
        "translation": "It's used to me not nibbling at random times."
    },
    "207": {
        "startTime": 1552.0,
        "endTime": 1556.69,
        "transcript": "Waten tang imumi ayuqellrunrilnguut au͡gkut yuut ciuqliit.",
        "translation": "You see, the ancestors long ago were not like this."
    },
    "208": {
        "startTime": 1556.69,
        "endTime": 1561.61,
        "transcript": "Cailkakun neramliurayuitut neryarat akulaitni.",
        "translation": "They don't nibble at random between meals."
    },
    "209": {
        "startTime": 1561.615,
        "endTime": 1564.37,
        "transcript": "Neryarat ukuullruameng pingayun:",
        "translation": "Becuase there were three meals:"
    },
    "210": {
        "startTime": 1564.37,
        "endTime": 1567.43,
        "transcript": "Unuakumi yuurqerluteng.",
        "translation": "They drank something hot in the morning."
    },
    "211": {
        "startTime": 1568.115,
        "endTime": 1573.81,
        "transcript": "Tua-i-ll' wani nutaan apiatani erenrem qukaani nerluteng neqpigmek.",
        "translation": "Then during lunch at noon they would eat real food."
    },
    "212": {
        "startTime": 1573.81,
        "endTime": 1578.25,
        "transcript": "Tua-i nerluta tua-i cunaw' aqsiluta tua-i tuani.",
        "translation": "We would eat and be full then."
    },
    "213": {
        "startTime": 1578.255,
        "endTime": 1584.91,
        "transcript": "Aqsitnguksaitelaryaaqut-llu cikiuteput aanamteńek. Cangimirrnaq'laryaaqellruut.",
        "translation": "What we were given from our mothers wouldn't be enough to fill. We'd want more."
    },
    "214": {
        "startTime": 1584.91,
        "endTime": 1588.69,
        "transcript": "Wani-llu atakumi tua-i atakutarluta.",
        "translation": "And here in the evening, we'd have dinner."
    },
    "215": {
        "startTime": 1588.695,
        "endTime": 1593.225,
        "transcript": "Tua-i-ll' kinguani ca igenqigtevkenaku unuakurvianun.",
        "translation": "Then after, we wouldn't ingest anything else until the morning."
    },
    "216": {
        "startTime": 1593.225,
        "endTime": 1598.605,
        "transcript": "Unugmi-llu elisngaluni iluvut meqsuyuunata unugmi.",
        "translation": "And at night, our stomachs were used to it, and we wouldn't be thirsty at night."
    },
    "217": {
        "startTime": 1598.84,
        "endTime": 1604.29,
        "transcript": "Unuakumi tau͡gaam tua-i uitaqatamta carrarmek tua-i.",
        "translation": "Only when we awoke in the morning would we have a little something."
    },
    "218": {
        "startTime": 1604.29,
        "endTime": 1611.76,
        "transcript": "Assaliarrluarmek-llu pikaitaqama wiinga taum aanama carraquinermek neqkuinermek cikiqatullruanga",
        "translation": "And when I didn't have a little pancake, my mother would give me a little piece of fish"
    },
    "219": {
        "startTime": 1611.76,
        "endTime": 1614.54,
        "transcript": "Pikartuyiqellrunrilamta.",
        "translation": "Because we didn't have an abundance."
    },
    "220": {
        "startTime": 1614.545,
        "endTime": 1620.435,
        "transcript": "Tua-i-ll' tauna cikiukarii ilayuunaku",
        "translation": "Then I wouldn't have more than what she gave"
    },
    "221": {
        "startTime": 1620.435,
        "endTime": 1622.855,
        "transcript": "Ilangnaqsuunaku-llu.",
        "translation": "And I wouldn't try to have more."
    },
    "222": {
        "startTime": 1622.92,
        "endTime": 1627.6,
        "transcript": "Waten tang yuum-wa tua-i man'a aturyugngakii.",
        "translation": "Like this you see, a person can practice this."
    },
    "223": {
        "startTime": 1627.605,
        "endTime": 1632.635,
        "transcript": "Maa-i makut kinguqlimta eliskunegteggu aturyugngaat.",
        "translation": "If our descendants learn it, they can practice it."
    },
    "224": {
        "startTime": 1632.945,
        "endTime": 1643.615,
        "transcript": "Uuggun kiingan wiinga ilumkun tamana tua-i maa-i ciumurutaqa man'a erneq engelkarrluku nerlalqa.",
        "translation": "With my stomach, I am going forth with with my eating habits to this day."
    },
    "225": {
        "startTime": 1644.315,
        "endTime": 1648.23,
        "transcript": "Au͡gkut tau͡gken ilait, cat tua-i makut",
        "translation": "Some of them however, these things"
    },
    "226": {
        "startTime": 1648.23,
        "endTime": 1653.49,
        "transcript": "Tua-i wii allaurcaaquq auluklemni cat makut.",
        "translation": "It's become different from how I've taken care of these things."
    },
    "227": {
        "startTime": 1653.655,
        "endTime": 1660.265,
        "transcript": "Tau͡gaam waten-llu tarrilluta nangengqaluta-llu iqemkarcecuitellruitkut.",
        "translation": "But, they never let us ingest anything walking around or standing."
    },
    "228": {
        "startTime": 1660.265,
        "endTime": 1663.44,
        "transcript": "Nerqercecuitellruitkut nangengqaluta.",
        "translation": "They never let us eat while standing."
    },
    "229": {
        "startTime": 1663.44,
        "endTime": 1670.49,
        "transcript": "Waten-llu maa-i tangvalalrianga, ava-i-llam unuaq itrama uani tangvalrianga elpeceńek",
        "translation": "I also see this now, and I just watch you as I came in this morning"
    },
    "230": {
        "startTime": 1670.49,
        "endTime": 1676.95,
        "transcript": "Kuuvvialrianek saskaq teguluku, tua-i-ll' piyuangluteng.",
        "translation": "Drinking coffee, taking the cup, then walking around."
    },
    "231": {
        "startTime": 1676.955,
        "endTime": 1680.91,
        "transcript": "Kaaka elluarrluni tut'elartuq qamavet ilumun.",
        "translation": "Listen, does it really settle well inside?"
    },
    "232": {
        "startTime": 1680.91,
        "endTime": 1683.78,
        "transcript": "Tua-i-w' cimiutii maa-i man'a.",
        "translation": "This is how it's changed."
    },
    "233": {
        "startTime": 1683.78,
        "endTime": 1687.83,
        "transcript": "Yuut au͡gkut ciuqliit alerqutiita cimiutekaa.",
        "translation": "It's how the instruction of the people back then has changed."
    },
    "234": {
        "startTime": 1687.83,
        "endTime": 1691.45,
        "transcript": "Itlemni unuaq tangvagamci tua-i.",
        "translation": "When I came in this morning, I watched you."
    },
    "235": {
        "startTime": 1691.525,
        "endTime": 1696.735,
        "transcript": "Imiriqaarluki una yuk apelcirpek'nani pak'mumun",
        "translation": "After this person fills their cup without asking permission from above"
    },
    "236": {
        "startTime": 1696.735,
        "endTime": 1703.25,
        "transcript": "Imiriqaarluni tua-i-ll' ayagluni, yuurqerluni piyualuni, enenun-llu itraqluni.",
        "translation": "After filling a cup, they go, drink while walking, and goes into rooms."
    },
    "237": {
        "startTime": 1703.25,
        "endTime": 1707.25,
        "transcript": "Tua-i tang maa-i man'a cimiutekaa.",
        "translation": "You see, that's how it's changed."
    },
    "238": {
        "startTime": 1707.255,
        "endTime": 1713.245,
        "transcript": "Qanlalriaci tua-i au͡gkut yuut ciuqliit yuullrat cimirniluku.",
        "translation": "You say that the lifestyle of people back then has changed."
    },
    "239": {
        "startTime": 1713.245,
        "endTime": 1715.945,
        "transcript": "Maa-i cimiutiin ilakaat man'a.",
        "translation": "This is one of the changes."
    },
    "240": {
        "startTime": 1716.12,
        "endTime": 1721.36,
        "transcript": "Atam irniangamta-llu",
        "translation": "You see, when we had children"
    },
    "241": {
        "startTime": 1722.595,
        "endTime": 1728.43,
        "transcript": "Qurrellranun teq'urranun uqlautevkayuitellruat.",
        "translation": "They never let them be soiled by their urine."
    },
    "242": {
        "startTime": 1728.43,
        "endTime": 1733.89,
        "transcript": "Terr'iliciqcaarluki irniaput aulukellrunritaput ciuqliit.",
        "translation": "We didn't take care of our children by putting them in diapers."
    },
    "243": {
        "startTime": 1733.895,
        "endTime": 1741.935,
        "transcript": "Maa-i ukaqvani terr'ilitaryaurtellruut mikelnguut Kass'alingan.",
        "translation": "More recently, children have started wearing diapers because of increased Westernization."
    },
    "244": {
        "startTime": 1742.03,
        "endTime": 1749.21,
        "transcript": "Wangkuta irniatullruukut pek'artellrat unugmi tamalkuan makyulluku.",
        "translation": "We used to take care of children, getting up every time they moved at night."
    },
    "245": {
        "startTime": 1749.215,
        "endTime": 1752.93,
        "transcript": "Qessaniutullruukut irnialriani.",
        "translation": "We with children couldn't afford to be lazy."
    },
    "246": {
        "startTime": 1752.93,
        "endTime": 1758.74,
        "transcript": "Mikelnguut-wa tua-i kenekngamteki. Kenekpiarluki auluktullruaput.",
        "translation": "It's because we loved children. We took care of them with great love."
    },
    "247": {
        "startTime": 1758.74,
        "endTime": 1763.43,
        "transcript": "Unitaayuunaki babysit-ayuunata-llu.",
        "translation": "We didn't keep leaving them, and we wouldn't babysit."
    },
    "248": {
        "startTime": 1763.43,
        "endTime": 1770.98,
        "transcript": "Wiinga-ll' waniwa irnillruyaaqua qula cetamanek cipluku.",
        "translation": "Now, I have borne 14 children."
    },
    "249": {
        "startTime": 1770.98,
        "endTime": 1774.18,
        "transcript": "Au͡gkut qulen",
        "translation": "Those ten"
    },
    "250": {
        "startTime": 1774.185,
        "endTime": 1782.58,
        "transcript": "Ukut wani qulen enemni antellruanka ayayuunii hospital-aamun.",
        "translation": "These ten, I gave birth to in my home without going to the hospital."
    },
    "251": {
        "startTime": 1782.58,
        "endTime": 1786.41,
        "transcript": "Tua-i-llu ukut wani qulem cipneri cetaman",
        "translation": "Then these other four after the ten"
    },
    "252": {
        "startTime": 1786.41,
        "endTime": 1791.96,
        "transcript": "Man'a temka qaillun ayuqngan nutaan",
        "translation": "Only when my body here was not completely healthy"
    },
    "253": {
        "startTime": 1792.82,
        "endTime": 1798.67,
        "transcript": "Wavet ayaglua ukut cetaman ancartularyaaqellruanka.",
        "translation": "I'd come here and give birth to these four."
    },
    "254": {
        "startTime": 1798.67,
        "endTime": 1803.85,
        "transcript": "Tau͡gaam ukut wani irnivigmi anellrunritut pingayun.",
        "translation": "But three of these were not born in the maternity ward."
    },
    "255": {
        "startTime": 1803.855,
        "endTime": 1810.13,
        "transcript": "Una tau͡gaam nangneqlikacaaq kinguqlikacaaq irnivigmun anellruuq.",
        "translation": "Only this very last youngest one was born in the maternity ward."
    },
    "256": {
        "startTime": 1810.13,
        "endTime": 1821.36,
        "transcript": "Tua-i-wa ak'anun nangtequmayuunii, nepliriyuunii ak'anun",
        "translation": "It's because I wouldn't suffer for a long time, not be in labor for long"
    },
    "257": {
        "startTime": 1821.36,
        "endTime": 1827.08,
        "transcript": "Nangteqnamek imumek irniam anellranek pillruama.",
        "translation": "Because I experienced the suffering of childbirth."
    },
    "258": {
        "startTime": 1827.085,
        "endTime": 1830.9,
        "transcript": "Tua-i nallunrilkemnek qanertua.",
        "translation": "I've said what I know."
    },
    "259": {
        "startTime": 1830.9,
        "endTime": 1835.01,
        "transcript": "Taum qingaqerraallemni aanama alerqulallruanga",
        "translation": "When I was first pregnant, my mother would instruct me"
    },
    "260": {
        "startTime": 1837.75,
        "endTime": 1847.27,
        "transcript": "\"Assirluten irnituyukuvet, assirluten-llu neplirituyukuvet ak'anun pivkenak",
        "translation": "\"If you want to give birth well, and if you want good labors without going for a long time"
    },
    "261": {
        "startTime": 1847.425,
        "endTime": 1853.395,
        "transcript": "\"Unugmi-llu erenrani-llu umyuarteqellren tamalkuan anlaqina ellamun.\"",
        "translation": "\"At night and day, every time you think of it, go outside.\""
    },
    "262": {
        "startTime": 1853.395,
        "endTime": 1860.645,
        "transcript": "Tang tamakut asgurakevkenaki wangkuta alerquukaraput atullrukput.",
        "translation": "You see, we didn't doubt what instructions we were given as we practiced them."
    },
    "263": {
        "startTime": 1862.635,
        "endTime": 1864.69,
        "transcript": "Atutullrukput.",
        "translation": "We'd practice them."
    },
    "264": {
        "startTime": 1864.69,
        "endTime": 1871.44,
        "transcript": "Tua-i-llu mikelnguq yuurcan tua-i wangkuta aulukluku.",
        "translation": "Then when the child was born, we took care of them."
    },
    "265": {
        "startTime": 1871.44,
        "endTime": 1875.52,
        "transcript": "Aulukeqtarluku ayuqucirturterluta aanamteńek.",
        "translation": "We'd take care of the dear one with our mothers to instruct us."
    },
    "266": {
        "startTime": 1875.525,
        "endTime": 1881.66,
        "transcript": "Unugmi serr'illra tamalkuan qurrucirluku mikcuayaaq anenenrrayaaq.",
        "translation": "When they stirred as they got up and night, we let the tiny newborn urinate."
    },
    "267": {
        "startTime": 1881.66,
        "endTime": 1888.18,
        "transcript": "Tuatnaurluku mecungcuunaku, aci kinerqurtelluku, uqlayuunaku.",
        "translation": "Always doing that, we didn't let it get wet, kept the bedding dry, never soiling it."
    },
    "268": {
        "startTime": 1888.645,
        "endTime": 1895.555,
        "transcript": "Tua-i-llu wiinga tamaani pingama sass'at elicamki makut sass'artangan",
        "translation": "Then back when I did that and learned about clocks when clocks came"
    },
    "269": {
        "startTime": 1895.555,
        "endTime": 1901.01,
        "transcript": "Sass'akun analallrat qurr'lallrat-llu nallunrirluku.",
        "translation": "I learned the times when they defecated and urinated."
    },
    "270": {
        "startTime": 1901.01,
        "endTime": 1904.88,
        "transcript": "Tua-i aulukilallruunga nutaan.",
        "translation": "Then I started taking care of them."
    },
    "271": {
        "startTime": 1904.88,
        "endTime": 1911.77,
        "transcript": "Atam imkut aulukestemta aanamta qanrutetullrukaitkut",
        "translation": "You see, our caretakers, our mothers, would tell us"
    },
    "272": {
        "startTime": 1911.77,
        "endTime": 1917.14,
        "transcript": "\"Anglirikan qanpagatelaryaqunaku.",
        "translation": "\"When they grow up, don't raise your voice at them."
    },
    "273": {
        "startTime": 1917.14,
        "endTime": 1921.16,
        "transcript": "\"Inerqulaqiu erinan tapirpek'naku.",
        "translation": "\"Admonish them without adding to your voice."
    },
    "274": {
        "startTime": 1921.165,
        "endTime": 1925.1,
        "transcript": "\"Tuaten pilaquvni niisngaciqaaten.",
        "translation": "\"If you do that, they will be obedient to you."
    },
    "275": {
        "startTime": 1925.1,
        "endTime": 1934.34,
        "transcript": "\"Tua-i tau͡gken erinan tapirluku, qastuluten-llu, qatgulluku-llu pilaquvni",
        "translation": "\"However, if you add to your voice, speak loudly to them, and shout at them"
    },
    "276": {
        "startTime": 1934.345,
        "endTime": 1938.015,
        "transcript": "\"Tuaten mikelnguq assirluni yuungaituq.",
        "translation": "\"The child will not live well like that."
    },
    "277": {
        "startTime": 1938.015,
        "endTime": 1942.195,
        "transcript": "\"Pamaitarkauguq niicuitarkauluni-llu.\"",
        "translation": "\"They will be stubborn and disobedient.\""
    },
    "278": {
        "startTime": 1943.41,
        "endTime": 1950.12,
        "transcript": "Wiinga tang waten mat'umek nallunrilkemnek alerquukaramnek qanelrianga.",
        "translation": "You see, I'm speaking about what I know of what I was instructed."
    },
    "279": {
        "startTime": 1953.15,
        "endTime": 1962.5,
        "transcript": "Au͡gkut tua-i ava-i waten qanlalriit-wa tua-i qanelrianek niitelalrianga",
        "translation": "About those, they say, and I've heard them say"
    },
    "280": {
        "startTime": 1962.5,
        "endTime": 1967.29,
        "transcript": "Yuullrat-gguq Yupiit cimirtuq maa-i.",
        "translation": "They say the Yup'ik lifestyle has changed now."
    },
    "281": {
        "startTime": 1967.29,
        "endTime": 1969.45,
        "transcript": "Ava-i cimiutait.",
        "translation": "Those are the changes."
    },
    "282": {
        "startTime": 1969.455,
        "endTime": 1976.43,
        "transcript": "Atam ca tamalkuan qanruyutengqellrulria wangkutni.",
        "translation": "Look, everything had traditional wisdom to us."
    },
    "283": {
        "startTime": 1976.43,
        "endTime": 1979.17,
        "transcript": "Ayuqucirtuuterluni.",
        "translation": "They had instructions."
    },
    "284": {
        "startTime": 1981.195,
        "endTime": 1986.83,
        "transcript": "Iliini narurtaqamteki",
        "translation": "Sometimes, when we disobey them"
    },
    "285": {
        "startTime": 1986.83,
        "endTime": 1993.81,
        "transcript": "Umyuarniurutetangqelartuq cali tamana qanruyun narurtellranek.",
        "translation": "There is also regret about disobeying that traditional wisdom."
    },
    "286": {
        "startTime": 1997.085,
        "endTime": 2003.915,
        "transcript": "Tamaa-i tua-i nallunrita'arqemnek mikelnguliuryaramek, kenkiyaramek mikelngurnek.",
        "translation": "That is what I know about raising children, loving children."
    },
    "287": {
        "startTime": 2003.915,
        "endTime": 2010.565,
        "transcript": "Yuum kenkekuniu mikelnguq tua-i tuaten kenekluku aulukarkaullinia.",
        "translation": "If a person loves a child, then they must take care of them with love like that."
    },
    "288": {
        "startTime": 2010.565,
        "endTime": 2015.075,
        "transcript": "Cali nalluvkarpek'naki picurlagnarqelriit.",
        "translation": "Also, let them know about what will bring them misfortune."
    },
    "289": {
        "startTime": 2015.075,
        "endTime": 2024.31,
        "transcript": "Kiaresngialutkai, itengqatkai nalluvkarpek'naki, itercivigmelutekai.",
        "translation": "Let them know about what will bring them shame, get them incarcerated, what will put them in jail."
    },
    "290": {
        "startTime": 2024.31,
        "endTime": 2030.77,
        "transcript": "Atam arcaqalriarulriit angayuqrulriani wangkuta irniaput",
        "translation": "You see, the most important things for us parents with our children"
    },
    "291": {
        "startTime": 2031.095,
        "endTime": 2036.47,
        "transcript": "Itercivigmun-llu ayautaqatki pitsaqevkenani ilamta",
        "translation": "When one of our relatives happens to be brought to jail"
    },
    "292": {
        "startTime": 2036.47,
        "endTime": 2045.91,
        "transcript": "Angayuqaagken elluarrlutek ilamegnek ilaliurciigalitek'laragkek tamakut",
        "translation": "They parents cannot socialize well with their relatives because of those"
    },
    "293": {
        "startTime": 2045.915,
        "endTime": 2052.005,
        "transcript": "Elkenka-wa tua-i anglicallruamegenki, aulukellruamegenki.",
        "translation": "Because they raised them, took care of them."
    },
    "294": {
        "startTime": 2052.215,
        "endTime": 2056.21,
        "transcript": "Man'a tang tua-i cimiutii.",
        "translation": "You see, this is how it's changed."
    },
    "295": {
        "startTime": 2056.21,
        "endTime": 2065.34,
        "transcript": "Ava-i cimirniluki au͡gkut yuut, yullret au͡gkut piciryarallrat cimirniluki tua-i qanlalriaci.",
        "translation": "You say that those people have changed, that the traditional ways of people back then have changed."
    },
    "296": {
        "startTime": 2065.34,
        "endTime": 2068.07,
        "transcript": "Tua-i nalluvkenaku-llu maa-i cimillra.",
        "translation": "And we know that it's changed now."
    },
    "297": {
        "startTime": 2068.07,
        "endTime": 2076.22,
        "transcript": "Ava-i tua-i nallunrita'arqevceńek au͡g'umek ciuqlilirluku cimillret iliit.",
        "translation": "I first started what what you know about one of the changes."
    },
    "298": {
        "startTime": 2076.22,
        "endTime": 2082.24,
        "transcript": "Tarrilluta wangkuta iluliurcecuitellruitkut.",
        "translation": "They wouldn't have us ingest anything walking around."
    },
    "299": {
        "startTime": 2082.245,
        "endTime": 2089.455,
        "transcript": "Meqsukapiarangramta-llu nerrlemta kinguani egmian mermek cikiliyuitellruitkut.",
        "translation": "And though we were very thirsty after eating, they wouldn't give us water right away."
    },
    "300": {
        "startTime": 2089.455,
        "endTime": 2095.685,
        "transcript": "Tua-i-llu tua-i kinerluku qanerput ugaani meqsuum.",
        "translation": "Then our mouths would be dry because we were so thirsty."
    },
    "301": {
        "startTime": 2095.685,
        "endTime": 2100.175,
        "transcript": "Qat'riluni-llu nuak tamana.",
        "translation": "And that saliva turned white."
    },
    "302": {
        "startTime": 2100.175,
        "endTime": 2106.445,
        "transcript": "Tuatnaaqan tau͡gaam tua-i mequinermek cikiqalallruitkut, tua-i-llu tauna meq'erluku.",
        "translation": "Only when that happened did they give us a little water, then we drank that."
    },
    "303": {
        "startTime": 2106.445,
        "endTime": 2113.385,
        "transcript": "Cangimirterpangramta-llu ilavkenaku, ilavkayuunaku.",
        "translation": "And though we really wanted more, we didn't have more, they didn't let us have more."
    },
    "304": {
        "startTime": 2114.1,
        "endTime": 2117.56,
        "transcript": "Neryarat atanqurluki.",
        "translation": "We waited for meals."
    },
    "305": {
        "startTime": 2117.565,
        "endTime": 2124.32,
        "transcript": "Tua-i elisngaluku. Wii tua-i waniw' tamana aulukutelqa aanamanek.",
        "translation": "We were used to it. That is how I was taken care of by my mother."
    },
    "306": {
        "startTime": 2124.32,
        "endTime": 2129.13,
        "transcript": "Iluma kiimi tua-i maligtaa, elisngaa.",
        "translation": "My stomach only follows it, is used to it."
    },
    "307": {
        "startTime": 2129.13,
        "endTime": 2135.28,
        "transcript": "Elilluku cailkakun neryarat avatiitni imiyuunani.",
        "translation": "It got used to not being filled randomnly outside of meals."
    },
    "308": {
        "startTime": 2136.97,
        "endTime": 2145.84,
        "transcript": "Au͡gna ava-i qalarqurallren mumigcugyaaqaqa Kass'acetun [?] qalarcuilan.",
        "translation": "I want to translate what you've said into English because [?] does not speak [Yup'ik]."
    },
    "309": {
        "startTime": 2145.84,
        "endTime": 2150.46,
        "transcript": "Ava-i-llu qanrutaqa, terr'ilitangqessuitellruut mikelnguut.",
        "translation": "And I just said that children didn't have diapers."
    },
    "310": {
        "startTime": 2150.465,
        "endTime": 2153.275,
        "transcript": "Tamaavet elliluki auluksuitellruaput.",
        "translation": "We didn't put them in those to take care of them."
    },
    "311": {
        "startTime": 2153.275,
        "endTime": 2159.975,
        "transcript": "Tua-i tau͡gaam murilkurluki tua-i qurrlerkait cailkamun pivkanritengnaqluki.",
        "translation": "Instead, we watched for when they urinated to keep them from doing it on the floor."
    },
    "312": {
        "startTime": 2161.9,
        "endTime": 2163.66,
        "transcript": "She said that...",
        "translation": "She said that..."
    },
    "313": {
        "startTime": 2164.295,
        "endTime": 2168.35,
        "transcript": "Wiinga-gguq aanama piqarraallemni ikayullruanga.",
        "translation": "My mom said the helped me my first time."
    },
    "314": {
        "startTime": 2168.35,
        "endTime": 2171.89,
        "transcript": "Tau͡gaam irnillma kinguani",
        "translation": "But after I gave birth"
    },
    "315": {
        "startTime": 2171.895,
        "endTime": 2177.325,
        "transcript": "Irnilua ataucirqumek aanama ikayullruanga ciuqlikacaarmek.",
        "translation": "Giving birth once, my mother helped me with the eldest."
    },
    "316": {
        "startTime": 2179.135,
        "endTime": 2185.27,
        "transcript": "Tua-i-llu kinguani irniqataama tungiinek",
        "translation": "Then afterwards, when I was going to give birth to the second"
    },
    "317": {
        "startTime": 2185.27,
        "endTime": 2192.55,
        "transcript": "Ikani Mamterillermiupiallerni ingkuni misviim nunallrani",
        "translation": "Across there in the original Bethel over there around the airport"
    },
    "318": {
        "startTime": 2192.555,
        "endTime": 2196.55,
        "transcript": "Tungiinek ciuqliim irniama irnillruunga.",
        "translation": "I gave birth to the second after the first."
    },
    "319": {
        "startTime": 2196.55,
        "endTime": 2199.93,
        "transcript": "Nallunritua anqatallrani.",
        "translation": "I knew when [s]he was going to be born."
    },
    "320": {
        "startTime": 2200.545,
        "endTime": 2210.94,
        "transcript": "Nallunrilama-llu uptellruunga acikiurlua, tua-i irnikuma cururkamnek.",
        "translation": "And since I knew, I prepared by getting bedding, a mattress for when I gave birth."
    },
    "321": {
        "startTime": 2210.94,
        "endTime": 2216.18,
        "transcript": "Acikiurlua upqaarlua kiagmi piama July-ami",
        "translation": "After I prepared bedding, since I did it in the summer in July"
    },
    "322": {
        "startTime": 2216.185,
        "endTime": 2223.335,
        "transcript": "July 6-aami aipirilua irnillemnek.",
        "translation": "I gave birth a second time on July 6."
    },
    "323": {
        "startTime": 2225.945,
        "endTime": 2232.815,
        "transcript": "Tua-i-llu piama upqaarlua nuussicuagnek pilua",
        "translation": "Then after I prepared, I took scissors"
    },
    "324": {
        "startTime": 2232.815,
        "endTime": 2237.285,
        "transcript": "Tangvallruamku aanaka ciuqlirmek irnillemni aulukillra.",
        "translation": "Since I watched my mother taking care of me in my first childbirth."
    },
    "325": {
        "startTime": 2237.285,
        "endTime": 2243.345,
        "transcript": "Nuussicuagnek paivcilua yualukamek-llu qillrutartarkagnek.",
        "translation": "I set out scissors and thread to tie with."
    },
    "326": {
        "startTime": 2243.85,
        "endTime": 2249.57,
        "transcript": "Tua-i-llu tauna mikelnguq anngan wangnek aulukluku.",
        "translation": "Then when that child was born, I took care of it myself."
    },
    "327": {
        "startTime": 2251.105,
        "endTime": 2256.7,
        "transcript": "Qallacia, uskuraa, man'a ingna-w' iqua.",
        "translation": "The belly button, umbilical cord, and the end over there."
    },
    "328": {
        "startTime": 2256.7,
        "endTime": 2264.46,
        "transcript": "Anngan uuggun qillerrluku, uuggun-llu qillerrluku, qukaagnegun-llu nuussicuarluku kepluku.",
        "translation": "When [s]he was born, tie it here, and tie it here, then I scissored the middle the cut it."
    },
    "329": {
        "startTime": 2264.465,
        "endTime": 2267.295,
        "transcript": "Tua-i wangnek aulukurallruanka.",
        "translation": "I took care of them myself."
    },
    "330": {
        "startTime": 2267.295,
        "endTime": 2275.43,
        "transcript": "Ukut tau͡gaam tua-i cetaman piani anellret qulem cipneri, ten-aam cipneri ukut wani",
        "translation": "But the four who were born inland after the ten, these ones after the ten"
    },
    "331": {
        "startTime": 2275.43,
        "endTime": 2280.27,
        "transcript": "Fourteen-aarqunek pillruama mat'umek qanemcitamci.",
        "translation": "Since I did it fourteen times, I'm telling you this story."
    },
    "332": {
        "startTime": 2280.665,
        "endTime": 2284.935,
        "transcript": "[?] was the father ever involved in this?",
        "translation": "[?] was the father ever involved in this?"
    },
    "333": {
        "startTime": 2285.545,
        "endTime": 2289.595,
        "transcript": "Did you understand? Let me intrepret back for those that didn't understand.",
        "translation": "Did you understand? Let me intrepret back for those that didn't understand."
    },
    "334": {
        "startTime": 2290.845,
        "endTime": 2296.72,
        "transcript": "Ilait-wa piniatelaameng arnat tamaani",
        "translation": "Since some women were frail back then"
    },
    "335": {
        "startTime": 2296.72,
        "endTime": 2301.21,
        "transcript": "Allamek arnamek nunameggni pitaitaqan",
        "translation": "When there was no other woman in their village"
    },
    "336": {
        "startTime": 2301.38,
        "endTime": 2306.01,
        "transcript": "Kiimeng, kiimenatek piaqamek ikayuqlutek",
        "translation": "When they were alone and helped each other"
    },
    "337": {
        "startTime": 2306.01,
        "endTime": 2313.05,
        "transcript": "Uum uingan tua-i tamakut qallaciit qillerrluki kepluki-llu.",
        "translation": "Her husband would tie those umbilical cords and cut them."
    },
    "338": {
        "startTime": 2314.895,
        "endTime": 2326.365,
        "transcript": "Arnaq canimelkeḿeggni pitangqerraqan taum aipaan kel'tua tauna aipani piniluku nayuusqelluku.",
        "translation": "When there was a woman nearby, her spouse would invite her, saying that his spouse was [giving birth] and to be her midwife."
    },
    "339": {
        "startTime": 2326.365,
        "endTime": 2335.625,
        "transcript": "Tua-i allam arnam tua-i ikayutuluku tauna wii nallunritlemni tua-i tamaani.",
        "translation": "Another woman would help her from what I know of back then."
    },
    "340": {
        "startTime": 2336.03,
        "endTime": 2342.57,
        "transcript": "Aipaan tau͡gken tua-i ikayurtekailami, ikayurtekaitaqamek",
        "translation": "However, her spouse, when he didn't have help, when they didn't have help"
    },
    "341": {
        "startTime": 2342.575,
        "endTime": 2348.785,
        "transcript": "Ellminek piyugnganritaqan aipaan ikayutuluku irniari.",
        "translation": "When she couldn't do it alone, her spouse would help her in childbirth."
    },
    "342": {
        "startTime": 2349.195,
        "endTime": 2352.55,
        "transcript": "Au͡gna tua-i waten ayuquq.",
        "translation": "This is what that's like."
    },
    "343": {
        "startTime": 2352.55,
        "endTime": 2360.32,
        "transcript": "Tua-ll' cali mikelnguut kenciyaraatnek",
        "translation": "Then also, watching over children respectfully"
    },
    "344": {
        "startTime": 2360.79,
        "endTime": 2365.94,
        "transcript": "Cali ilii waten ayuquq:",
        "translation": "Part of it is also like this:"
    },
    "345": {
        "startTime": 2366.83,
        "endTime": 2375.85,
        "transcript": "Mikelnguq tua-i maktesciigataqami cali elitnaullerkaa nallunalartuq.",
        "translation": "When a child can't get up [from sleep], they don't know when they're taught."
    },
    "346": {
        "startTime": 2375.855,
        "endTime": 2382.03,
        "transcript": "Camek-llu qanrut'nge'rmi taringyuunani, taringyaurteksaunani.",
        "translation": "And though they're told something, they don't understand yet."
    },
    "347": {
        "startTime": 2382.03,
        "endTime": 2390.35,
        "transcript": "Nutaan-llu tua-i makcan, temni pinirian makcan, aqumgayaurcan",
        "translation": "Then when they get up, when their bodies are strong as they get up, when they start sitting"
    },
    "348": {
        "startTime": 2391.455,
        "endTime": 2399.565,
        "transcript": "Nutaan aarnarqellriit elliinun cali waten estuulumi ner'aqameng uuqnarqellriit",
        "translation": "Those things that are dangerous to them, the hot food on the table when they ate"
    },
    "349": {
        "startTime": 2400.225,
        "endTime": 2406.695,
        "transcript": "Tua-i tauna uuqitlerkaa nalluagua taum mikelnguum",
        "translation": "Since that child doesn't know about getting burned"
    },
    "350": {
        "startTime": 2406.695,
        "endTime": 2413.105,
        "transcript": "Elliinun mikelngurmun agtuq'ertelluku tauna uuqnarqelria.",
        "translation": "Have that child touch that hot thing."
    },
    "351": {
        "startTime": 2413.105,
        "endTime": 2421.88,
        "transcript": "Tua-i-llu kinguani pirraarluku naspaaluku taumek imumun agturcetaaruarluku.",
        "translation": "Then after doing that, try to let them touch that [again]."
    },
    "352": {
        "startTime": 2421.88,
        "endTime": 2428.77,
        "transcript": "Ak'a tua-i eligarrluku. Imum mikelnguum uuqnarqucia nallunriqerrluku.",
        "translation": "They already learn. That child knows that it's hot."
    },
    "353": {
        "startTime": 2428.92,
        "endTime": 2438.43,
        "transcript": "Tua-i-gguq uuqitlerkaa man'a nallumini qaillun pikan uuqnarqellria taum nallunrirluku.",
        "translation": "They said that for getting accidentally burned, they know what is hot."
    },
    "354": {
        "startTime": 2439.13,
        "endTime": 2448.0,
        "transcript": "Waten elpengcuaralriatun ayuqelaameng aqumgayaurtaqameng",
        "translation": "Because it's like they become a little aware when they start sitting"
    },
    "355": {
        "startTime": 2448.0,
        "endTime": 2452.08,
        "transcript": "Neryaurtaqameng-llu nerqelluki piaqameng",
        "translation": "And when fed when they start eating"
    },
    "356": {
        "startTime": 2452.255,
        "endTime": 2457.795,
        "transcript": "Tua-i tamakunek elicungcaaralaraa tauna irniani.",
        "translation": "They teach their child of those."
    },
    "357": {
        "startTime": 2458.59,
        "endTime": 2462.96,
        "transcript": "Cali-llu tua-i camek pian",
        "translation": "Then when they do something"
    },
    "358": {
        "startTime": 2463.73,
        "endTime": 2470.26,
        "transcript": "Cali mat'um teguyullranek inerqurluku cali.",
        "translation": "Also admonish them when they try to grab things too much."
    },
    "359": {
        "startTime": 2470.37,
        "endTime": 2475.85,
        "transcript": "Tua-i tegularcetevkenaku, elliinun teguyugcetevkenaku.",
        "translation": "Don't let them take it, don't let them take it."
    },
    "360": {
        "startTime": 2476.015,
        "endTime": 2483.775,
        "transcript": "Tamaa-i-am-gguq teguyugtelluku mikelnguq anglica'arqami tua-i",
        "translation": "They say that when a child grows up grabbing things"
    },
    "361": {
        "startTime": 2483.82,
        "endTime": 2487.73,
        "transcript": "Teguqailitavkarluku tua-i makunek",
        "translation": "Allowing them to grab these things"
    },
    "362": {
        "startTime": 2487.73,
        "endTime": 2497.07,
        "transcript": "Tua-i anglicuariimi, angliami pinariami",
        "translation": "When they grow up a little, when they grow up and become able"
    },
    "363": {
        "startTime": 2497.225,
        "endTime": 2505.62,
        "transcript": "Cali tamakunek teguyullerminek imkunek caperqenrirluki.",
        "translation": "They are no longer inhibited from taking things."
    },
    "364": {
        "startTime": 2505.62,
        "endTime": 2510.09,
        "transcript": "Tua-i yuum-llu pia teguyukuniu teguyugngaluku.",
        "translation": "They can also take someone of another person if they want to."
    },
    "365": {
        "startTime": 2510.09,
        "endTime": 2518.47,
        "transcript": "Ak'a tua-i tamaani pivkenani inerquumavkenani teguyugtaciatun piyugtaciatun pivkarluku.",
        "translation": "A long time ago, they were not admonished, but were allowed to take whatever they wanted."
    },
    "366": {
        "startTime": 2518.625,
        "endTime": 2528.06,
        "transcript": "Tua-i tau͡gaam tuani piqarraami inerquulluki tamakut pikuniki",
        "translation": "But if they admonish against those from the start"
    },
    "367": {
        "startTime": 2528.06,
        "endTime": 2532.69,
        "transcript": "Tua-i-am tuaten cali elitkanirluni.",
        "translation": "They will also learn more like that."
    },
    "368": {
        "startTime": 2533.12,
        "endTime": 2538.81,
        "transcript": "Cali tua-i taringecuaryaurcan nutaan, taringyaurcan mikelnguq",
        "translation": "Also, when they start understanding, when a child starts understanding"
    },
    "369": {
        "startTime": 2538.81,
        "endTime": 2544.46,
        "transcript": "Qanllemteńek wangkuta taringyaurcan anglikanian",
        "translation": "When they understand what we say as they grow more"
    },
    "370": {
        "startTime": 2544.855,
        "endTime": 2550.745,
        "transcript": "Qanruyutengqertukut wangkuta anglicartemteńek waten:",
        "translation": "We have this wisdom from those who raised us:"
    },
    "371": {
        "startTime": 2550.745,
        "endTime": 2553.645,
        "transcript": "Waten-gguq irniangekumta",
        "translation": "They said if we have children like this"
    },
    "372": {
        "startTime": 2554.04,
        "endTime": 2561.73,
        "transcript": "Mikelnguq-gguq unuakumi tupakarraaraqami ellangqelartuq.",
        "translation": "They said that when a child first wakes up on the morning, they are aware."
    },
    "373": {
        "startTime": 2562.23,
        "endTime": 2570.06,
        "transcript": "Tua-i akusrartevkenani makluni aaravkenani, engelallagavkenani, tau͡gaam nepaunani.",
        "translation": "They get up without being wily, not shouting, not bursting out laughing, but quiet."
    },
    "374": {
        "startTime": 2570.06,
        "endTime": 2572.48,
        "transcript": "Ellangqerrluni-gguq tua-i.",
        "translation": "They say they're aware."
    },
    "375": {
        "startTime": 2572.525,
        "endTime": 2584.035,
        "transcript": "Tua-i-gguq tuani nutaan ellangqellrani nutaan qanruyutmek qanrutecuaqaqluku piluku.",
        "translation": "They said that when they're aware to then tell them a piece of traditional wisdom."
    },
    "376": {
        "startTime": 2584.035,
        "endTime": 2593.105,
        "transcript": "Tua-i-gguq ellangqellermini tuani tauna qanruyutni murilkekuniu",
        "translation": "They said that as they are aware, if they pay attention to the wisdom passed down to them"
    },
    "377": {
        "startTime": 2594.285,
        "endTime": 2599.445,
        "transcript": "Imkunek-am qanlalriakut iliini, \"Tang, ellangartelliniuq.\"",
        "translation": "Sometimes we say, \"Look, they're aware.\""
    },
    "378": {
        "startTime": 2599.447,
        "endTime": 2606.127,
        "transcript": "Waten uitanqegcinga'arrluteng piaqata mikelnguut, \"Ellanga'rtuq,\" atauciq tangvanga'arrluku.",
        "translation": "When these children start staying still, \"They're aware,\" looking at one thing."
    },
    "379": {
        "startTime": 2606.136,
        "endTime": 2609.766,
        "transcript": "Tua-i-gguq unuakumi tuaten ayuquq.",
        "translation": "They say they're like that in the morning."
    },
    "380": {
        "startTime": 2609.777,
        "endTime": 2615.247,
        "transcript": "Tauna mikelnguq qanruskuni ellangqellriacetun.",
        "translation": "If that child is spoken to as if they were aware."
    },
    "381": {
        "startTime": 2615.258,
        "endTime": 2620.188,
        "transcript": "Imna-llu-gguq nalluyagutevkenaku, umyuaqenruluku.",
        "translation": "And they say they will not forget it, but remember it more clearly."
    },
    "382": {
        "startTime": 2620.192,
        "endTime": 2625.002,
        "transcript": "Tua-i tau͡gaam uitaqerluni atatakuani qanruyutmi kinguani.",
        "translation": "But they sit still later after they are given traditional wisdom."
    },
    "383": {
        "startTime": 2625.012,
        "endTime": 2630.962,
        "transcript": "Tua-i wangkuta-ll' tupa'agqamta pek'ngartelartukut tua-i cegvarrluta-llu.",
        "translation": "And when we wake up, we start moving about and [?becoming actively awake]."
    },
    "384": {
        "startTime": 2630.972,
        "endTime": 2635.282,
        "transcript": "Tua-i-ll' tauna imna mikelnguq uitanqegcirraarluni",
        "translation": "Then after that child sits still"
    },
    "385": {
        "startTime": 2635.34,
        "endTime": 2643.5,
        "transcript": "Nutaan tua-i pek'ngarrluni cali im' ellani tayim' nalluyaguarrngatellriacetun piluku.",
        "translation": "They start moving around as if they are not aware anymore."
    },
    "386": {
        "startTime": 2643.907,
        "endTime": 2647.937,
        "transcript": "Tua-i-llu anglikanian cali piluku",
        "translation": "Then when they grow up more, say to them"
    },
    "387": {
        "startTime": 2648.204,
        "endTime": 2652.124,
        "transcript": "\"Ilan, ilaten kenkurluku ata pikiki.\"",
        "translation": "\"Treat those around you with love, okay?\""
    },
    "388": {
        "startTime": 2652.137,
        "endTime": 2654.707,
        "transcript": "Tua-i waten qanrulluki mat'umek.",
        "translation": "Tell them about this."
    },
    "389": {
        "startTime": 2654.712,
        "endTime": 2661.922,
        "transcript": "Tua-i kenekngamiu ilain-llu, ilainun-llu kenkisqelluku qanrulluku.",
        "translation": "Since you love them, tell them to treat those around them with love."
    },
    "390": {
        "startTime": 2661.93,
        "endTime": 2666.91,
        "transcript": "\"Ilan, ilaten ata kenkurluki unuamek pikina.\"",
        "translation": "\"Treat those around you with love today, okay?\""
    },
    "391": {
        "startTime": 2667.289,
        "endTime": 2675.969,
        "transcript": "Tua-i-gguq taum aaniin wall'u atiin kenekngamiu tuaten cali elluarrluku ayaasqumaluku tamakunun",
        "translation": "They say that because their mother or father loves them, they want them to go [through life] well with them"
    },
    "392": {
        "startTime": 2675.973,
        "endTime": 2682.823,
        "transcript": "Tuaten alerquuka'rnek call' arcaqanruan kenkurluku ilai pisqelluki.",
        "translation": "Also because it's the most important traditional instruction, tell them to love those around them."
    },
    "393": {
        "startTime": 2682.834,
        "endTime": 2691.172,
        "transcript": "Tua-llu-gguq cali arnam iliini nakmiin irniaqenrilnge'rmiu tauna yuk",
        "translation": "Then they said that a woman sometimes, though that person is not her own child"
    },
    "394": {
        "startTime": 2691.184,
        "endTime": 2699.474,
        "transcript": "Mikelnguq yuum allam yua cali tangerquniu irniamitun imutun pitarrluku",
        "translation": "When she sees that child, another person's child, just like her own child"
    },
    "395": {
        "startTime": 2699.487,
        "endTime": 2708.407,
        "transcript": "Cali qanruyutmek cali qanrulluku kenekluku irniamitun pitarrluku.",
        "translation": "She also tells them of traditional wisdom, loving them as much as her own child."
    },
    "396": {
        "startTime": 2711.487,
        "endTime": 2716.217,
        "transcript": "Kangia tauna wii kangingumanritanka tau͡gatnatullrat.",
        "translation": "I don't understand the meaning of why they do that."
    },
    "397": {
        "startTime": 2716.227,
        "endTime": 2722.047,
        "transcript": "Tauna wangkutni Kiatiirmiuni maani tuatnatuukut-llu.",
        "translation": "We from the upper Nushagak River also do that."
    },
    "398": {
        "startTime": 2722.209,
        "endTime": 2729.889,
        "transcript": "Makunek alingnarqellrianek pitaqamta qavani, taqukanek-llu, tan'gerlinek-llu",
        "translation": "When we catch those dangerous things upriver, including grizzly bears, and black bears"
    },
    "399": {
        "startTime": 2729.979,
        "endTime": 2734.529,
        "transcript": "Tamakunek pitqerraaraqamta",
        "translation": "When we first catch those"
    },
    "400": {
        "startTime": 2735.065,
        "endTime": 2738.244,
        "transcript": "Imna auganek",
        "translation": "Its blood"
    },
    "401": {
        "startTime": 2740.221,
        "endTime": 2749.801,
        "transcript": "Pitamta taum alingnarqellriim qanra aitarrluku nuaganek kautetuukut tegulluta.",
        "translation": "We open the mouth of our dangerous catch, reach into it, and take some saliva."
    },
    "402": {
        "startTime": 2749.815,
        "endTime": 2755.245,
        "transcript": "Nutaan-ll' unatemteńun pirraarluku kegginamteńun minguulluku.",
        "translation": "Then after putting it on our hands, we apply it on our faces."
    },
    "403": {
        "startTime": 2755.249,
        "endTime": 2759.439,
        "transcript": "Tua-i-gguq tamatum pitarkam tangerqunikut",
        "translation": "They say that when that bear sees us"
    },
    "404": {
        "startTime": 2759.444,
        "endTime": 2765.784,
        "transcript": "Tamaaggun ellaitnguluta yuuluta ellmegcecicetun tangerqunegtekut",
        "translation": "Through that, when they see us living as one of them"
    },
    "405": {
        "startTime": 2767.399,
        "endTime": 2774.449,
        "transcript": "Ullagluta tua-i piarkauvkenata waten pitangyuutekluta.",
        "translation": "They will not come to us and do this, wanting to harm us."
    },
    "406": {
        "startTime": 2774.451,
        "endTime": 2781.791,
        "transcript": "Tamatumek takaryuuterluteng ellaita nuameggnek minguutellemteńun kegginamteńun.",
        "translation": "They respect their saliva that we applied to our faces."
    },
    "407": {
        "startTime": 2781.805,
        "endTime": 2784.375,
        "transcript": "Au͡g'utun ayuquq. (Ii-i.)",
        "translation": "That's what it's like. (I see.)"
    },
    "408": {
        "startTime": 2784.382,
        "endTime": 2790.432,
        "transcript": "Tua-i tuacetun pilarait alikluku tua-i piarkauvkenaku.",
        "translation": "They do that so that they will not fear [a bear]."
    },
    "409": {
        "startTime": 2790.623,
        "endTime": 2798.323,
        "transcript": "Okay, we asked the original question about the ritual of getting the first seal.",
        "translation": "Okay, we asked the original question about the ritual of getting the first seal."
    },
    "410": {
        "startTime": 2799.991,
        "endTime": 2807.281,
        "transcript": "Akaurtuq pinanriuciat makuneng agayulirteńeng makuneng pingata.",
        "translation": "It's been discontinued for a long time because there are these priests."
    },
    "411": {
        "startTime": 2807.296,
        "endTime": 2811.006,
        "transcript": "Maa-i akaurtuq pinanrillrat.",
        "translation": "It's been discontinued since a long time."
    },
    "412": {
        "startTime": 2811.014,
        "endTime": 2821.334,
        "transcript": "Wanigga kangia kangirqelluku kangia tauna ayagnengellran tau͡gatnayaurtellrata kenglii wanigg' nalqigutekqataraqa, qanrutkeqataraqa.",
        "translation": "I'm going to explain, talk about, the meaning of the time when they started doing that."
    },
    "413": {
        "startTime": 2821.452,
        "endTime": 2826.212,
        "transcript": "Ak'a-gguq au͡gani piyuitellruyaaqut, tau͡gatnayuitellruyaaqut.",
        "translation": "They said that long ago, they didn't used to do that."
    },
    "414": {
        "startTime": 2826.6,
        "endTime": 2835.252,
        "transcript": "Tau͡gaam taum mikelnguum atiin taum nakacugnun ayaucetellran",
        "translation": "But when that child's father had him sent to the bladders"
    },
    "415": {
        "startTime": 2835.263,
        "endTime": 2839.283,
        "transcript": "Ayautellrata taum ayaucitellrata",
        "translation": "When they had sent him"
    },
    "416": {
        "startTime": 2839.295,
        "endTime": 2847.785,
        "transcript": "Al'rrakurrluni uitaluni tamaani unguvalriit tamakut seal-at makliit ilagarluki uitallermini tau͡gani.",
        "translation": "When he had stayed there for a year with the living beings, along with the seals, the bearded seals back then."
    },
    "417": {
        "startTime": 2848.174,
        "endTime": 2854.224,
        "transcript": "Tekicami utercami al'rrakuan tau͡gaam keyianun tauna ayallni nallairngan",
        "translation": "Only when he had come back home the next year after his stay was complete"
    },
    "418": {
        "startTime": 2854.471,
        "endTime": 2858.821,
        "transcript": "Tamatumeng tau͡gatnayaurcitellrullinii taum mikelnguum.",
        "translation": "That child had them start doing that."
    },
    "419": {
        "startTime": 2860.197,
        "endTime": 2865.937,
        "transcript": "Tau͡gaten mermeng piyaurcitellrullinii tamakut seal-at.",
        "translation": "He had them start giving those seals water like that."
    },
    "420": {
        "startTime": 2867.947,
        "endTime": 2872.927,
        "transcript": "Taum tau͡ga tauna kengelkelluku piyaurtellrulliniit.",
        "translation": "After that time, they started doing that to [the seals]."
    },
    "421": {
        "startTime": 2872.931,
        "endTime": 2881.301,
        "transcript": "Taum mikelnguullermini ayallrem tamakunun unguvalriit nuniitnun ayagviatnun amavet kengllilluni.",
        "translation": "When he was a child, he had gone over there where the living [seals] go and stayed."
    },
    "422": {
        "startTime": 2881.31,
        "endTime": 2885.63,
        "transcript": "Uterrluni-llu keyianeng al'rrakunun, al'rrakuq naangan.",
        "translation": "And he only returned when a year had passed."
    },
    "423": {
        "startTime": 2885.646,
        "endTime": 2891.356,
        "transcript": "Ayallni tauna nallairngan tau͡gaam tekitellrulliniuq tauna.",
        "translation": "Only when it was time for him to go did he return."
    },
    "424": {
        "startTime": 2891.43,
        "endTime": 2894.39,
        "transcript": "Taum tau͡ga piyaurcitellrullinii.",
        "translation": "He started that tradition."
    },
    "425": {
        "startTime": 2894.48,
        "endTime": 2903.91,
        "transcript": "Tamakut seal-at pitaqaqamegki nakacuit egcuunaki qerrutullruit.",
        "translation": "When they caught those seals, they wouldn't throw their bladders away, but inflate them."
    },
    "426": {
        "startTime": 2904.16,
        "endTime": 2910.4,
        "transcript": "Unkut seal-at tamalkuita nakacuit qerrurluki, kiagpak-llu qemangqaluki.",
        "translation": "They inflated the bladders of every seal down there, and kept them all summer."
    },
    "427": {
        "startTime": 2910.411,
        "endTime": 2916.541,
        "transcript": "Uksuaran-llu nutaan qagerqelluki, cikum aciakun qerrluki tayim' atertelluki.",
        "translation": "Then only when fall set did they pop them, stuff them under the ice, and had them drift away."
    },
    "428": {
        "startTime": 2916.551,
        "endTime": 2922.161,
        "transcript": "Tua-i tuatnatullruit tamakut seal-at pitaqaqamegteki.",
        "translation": "They would do that with seals when they caught them."
    },
    "429": {
        "startTime": 2922.172,
        "endTime": 2929.762,
        "transcript": "Tua-i anernera tauna tuantelalliuq nakacuani. Tuancukluku pilarngatait.",
        "translation": "Its spirit might be there in its bladder. I think they say it's in the bladder."
    },
    "430": {
        "startTime": 2929.776,
        "endTime": 2935.356,
        "transcript": "Ataam-gguq tua-i taituut allamiani. Tuaten qantuluteng pitullruut tamakut.",
        "translation": "They say they come the next year. They would say that."
    },
    "431": {
        "startTime": 2935.368,
        "endTime": 2944.118,
        "transcript": "Taukut tua-i pitaqetukai-gguq tua-i tauna nakacuk ataam pitaqestektuminun utertetuluni pitaqetuluku.",
        "translation": "They say that those that were caught, that blatter returns to be caught again by the one who had caught it."
    },
    "432": {
        "startTime": 2944.976,
        "endTime": 2951.176,
        "transcript": "Tamatumek-am tuaten pinguartelluku pitullrulliniut.",
        "translation": "That's what they believed happened to them."
    },
    "433": {
        "startTime": 2951.252,
        "endTime": 2958.882,
        "transcript": "Ataam taisqumaluki nakacuit-llu ayagtelluki Nakaciuraqameng.",
        "translation": "They would send the bladders away, asking them to come again, when they held the Bladder Festival."
    },
    "434": {
        "startTime": 2958.889,
        "endTime": 2961.819,
        "transcript": "Ilii qanrutekluku, tauna-gguq tua-i...",
        "translation": "Speaking of part of it, they said that that..."
    },
    "435": {
        "startTime": 2961.832,
        "endTime": 2964.992,
        "transcript": "Wanikuaqu. Una mumigetrraarnauqa.",
        "translation": "Later. Let me translate this first."
    },
    "436": {
        "startTime": 2967.486,
        "endTime": 2968.946,
        "transcript": "Kurt Bell...",
        "translation": "Kurt Bell..."
    },
    "437": {
        "startTime": 2968.955,
        "endTime": 2973.485,
        "transcript": "Angalkum taukuk nulirqelriik yuak",
        "translation": "The shaman, the child of that couple"
    },
    "438": {
        "startTime": 2973.496,
        "endTime": 2980.566,
        "transcript": "Tua-i unguvayuunatek taukuk nulirqelriik yuk'ek ciungani, tuquurluteng.",
        "translation": "The children of that couple wouldn't live in the past, always dying."
    },
    "439": {
        "startTime": 2980.569,
        "endTime": 2989.769,
        "transcript": "Tua-i-llam tauna tua-i iliit irnian nutaan taum angalkum tuaten piyugluku taukuk yuak.",
        "translation": "Then one of their children, that shaman wanted to do that with their child."
    },
    "440": {
        "startTime": 2989.787,
        "endTime": 2994.407,
        "transcript": "Nakacugnun ilaulluku ayagcecugluku.",
        "translation": "He wanted to send him along with the bladders."
    },
    "441": {
        "startTime": 2994.412,
        "endTime": 3001.422,
        "transcript": "Tua-i taum angalkum tuaten pivkarluku tamakunun ungavalriat nuniitnun.",
        "translation": "The shaman did that, [sending] him to the place of those living beings."
    },
    "442": {
        "startTime": 3001.433,
        "endTime": 3006.633,
        "transcript": "Enenguluku tau͡gaam tauna unguvalriit nuniit tangerrluku elliin.",
        "translation": "But he saw the place of those living beings as a house."
    },
    "443": {
        "startTime": 3006.639,
        "endTime": 3013.589,
        "transcript": "Tua-i-w' tekicami makut seal-at nuniitnun uksurpak",
        "translation": "When he arrived to the place of these seals in the winter"
    },
    "444": {
        "startTime": 3013.606,
        "endTime": 3018.596,
        "transcript": "Ilaita-gguq-am tua-i nakukaqluku tauna.",
        "translation": "They said some of them picked on him."
    },
    "445": {
        "startTime": 3019.51,
        "endTime": 3026.43,
        "transcript": "Tauna ayagcetaulria nakacugteggun, tamakut seal-at issurit-llu.",
        "translation": "That one sent with the bladders [was picked on by] those seals and spotted seals."
    },
    "446": {
        "startTime": 3026.439,
        "endTime": 3029.249,
        "transcript": "Tua-i ayuqevkenateng tuani.",
        "translation": "They were different there."
    },
    "447": {
        "startTime": 3029.262,
        "endTime": 3033.532,
        "transcript": "Ilaita-gguq-am tau͡gken kenkurluku piaqluku tua-i tauna.",
        "translation": "However, they said some of them treated him with love."
    },
    "448": {
        "startTime": 3033.545,
        "endTime": 3038.325,
        "transcript": "Tua-i-gguq tamaani nutaan utertellmi kinguani pissuryaurcami",
        "translation": "They said that when after he went home and started hunting"
    },
    "449": {
        "startTime": 3038.33,
        "endTime": 3045.65,
        "transcript": "Elitaq'larai tamakut issurit wall'u nayiit.",
        "translation": "He would recognize those spotted seals or ringed seals."
    },
    "450": {
        "startTime": 3045.662,
        "endTime": 3049.462,
        "transcript": "Tua-i elitaqluki yugcetun wangkucicetun.",
        "translation": "He recognized them like us people."
    },
    "451": {
        "startTime": 3049.477,
        "endTime": 3058.697,
        "transcript": "Tua-i-gguq tamakut pissungellermini tamaani elitaq'laamiki pitpalarai cakneq tukniaqluki tua-i.",
        "translation": "They said that when he started hunting, since he recognized them, he would shoot arrows at them with great force."
    },
    "452": {
        "startTime": 3058.699,
        "endTime": 3065.419,
        "transcript": "Pitgarluki-w' tua-i, narulkarluki-ll', wall' cakneq tua-i elitaq'laamiki.",
        "translation": "He would shoot arrows at them, or harpoon them, doing it with force since he recognized them."
    },
    "453": {
        "startTime": 3065.436,
        "endTime": 3067.906,
        "transcript": "Tua-i tuaten tamana ayuquq.",
        "translation": "That's what that's like."
    },
    "454": {
        "startTime": 3067.908,
        "endTime": 3073.438,
        "transcript": "He expanded on that one about the boy going out to the seals.",
        "translation": "He expanded on that one about the boy going out to the seals."
    },
    "455": {
        "startTime": 3074.619,
        "endTime": 3082.145,
        "transcript": "There was a man and a wife whose children did not make it, kept dying, kept dying.",
        "translation": "There was a man and a wife whose children did not make it, kept dying, kept dying."
    },
    "456": {
        "startTime": 3082.152,
        "endTime": 3092.892,
        "transcript": "And so, this one child, the shaman asked the man and wife to send that child with bladders out to the sea.",
        "translation": "And so, this one child, the shaman asked the man and wife to send that child with bladders out to the sea."
    },
    "457": {
        "startTime": 3092.901,
        "endTime": 3097.211,
        "transcript": "And so, that's what he did.",
        "translation": "And so, that's what he did."
    },
    "458": {
        "startTime": 3099.023,
        "endTime": 3103.273,
        "transcript": "And then, that boy lived...",
        "translation": "And then, that boy lived..."
    },
    "459": {
        "startTime": 3103.443,
        "endTime": 3108.603,
        "transcript": "Tauna tau͡ga tau͡gatnaluni ayallrulliniuq tamakut nuniitnun tau͡gatnayarturluni",
        "translation": "That's how he went to their place to do that."
    },
    "460": {
        "startTime": 3108.613,
        "endTime": 3110.323,
        "transcript": "Okay, he...",
        "translation": "Okay, he..."
    },
    "461": {
        "startTime": 3110.335,
        "endTime": 3112.925,
        "transcript": "...larai caknerpak pivkenaki.",
        "translation": "...[?] does it without doing it too hard."
    },
    "462": {
        "startTime": 3113.475,
        "endTime": 3119.405,
        "transcript": "Tau͡gaam tamakut nakukesteńi tua-i-am tuaten pituluki.",
        "translation": "But he would do that with those that picked on him."
    },
    "463": {
        "startTime": 3119.411,
        "endTime": 3120.281,
        "transcript": "Tarringaqa.",
        "translation": "I understand it."
    },
    "464": {
        "startTime": 3120.839,
        "endTime": 3131.739,
        "transcript": "What he's saying is that those people that were, or, those seals that he recognized that were good to him",
        "translation": "What he's saying is that those people that were, or, those seals that he recognized that were good to him"
    },
    "465": {
        "startTime": 3131.75,
        "endTime": 3135.17,
        "transcript": "He made sure that he made a good, clean kill.",
        "translation": "He made sure that he made a good, clean kill."
    },
    "466": {
        "startTime": 3135.182,
        "endTime": 3139.172,
        "transcript": "You know, he really made sure that he did that.",
        "translation": "You know, he really made sure that he did that."
    },
    "467": {
        "startTime": 3139.267,
        "endTime": 3144.387,
        "transcript": "It seems like this was a really important ceremony to go through.",
        "translation": "It seems like this was a really important ceremony to go through."
    },
    "468": {
        "startTime": 3144.869,
        "endTime": 3150.89,
        "transcript": "Ciin-gguq Kass'at tekiqercilluki tau͡gaten pinanrillruat?",
        "translation": "Why did they stop that after Western contact?"
    },
    "469": {
        "startTime": 3154.801,
        "endTime": 3158.981,
        "transcript": "Agayulirtetangan pinanrirluki tuaten.",
        "translation": "They stopped doing that when priests came."
    },
    "470": {
        "startTime": 3159.124,
        "endTime": 3162.644,
        "transcript": "Agayulirteńeng makuneng tau͡ga pingan",
        "translation": "When these priests came"
    },
    "471": {
        "startTime": 3162.654,
        "endTime": 3172.334,
        "transcript": "Tamana tamaa-i qulirat makuneng agayulirteńeng pitangengan tamana tau͡gatnayaraq pegtelqaat aturnanrirluku.",
        "translation": "With those legends, when these priests came, they relinquished that practice and stopped doing it."
    },
    "472": {
        "startTime": 3172.341,
        "endTime": 3174.071,
        "transcript": "Ii-i, waten-qaa?",
        "translation": "I see, like this?"
    },
    "473": {
        "startTime": 3174.154,
        "endTime": 3180.194,
        "transcript": "Ukuk naliagneng: kayngukluku, wall'u-qaa taqesqelqaaci?",
        "translation": "Which of these: out of shame, or did they tell you to stop?"
    },
    "474": {
        "startTime": 3180.957,
        "endTime": 3187.127,
        "transcript": "Taqesqenrilengraiciteng tau͡ga tamana tamaa-i aturnanrillruat.",
        "translation": "Though they weren't told to stop, they stopped practicing that."
    },
    "475": {
        "startTime": 3187.555,
        "endTime": 3195.055,
        "transcript": "Camun tamana aturyararteng tamakunun seal-anun atutukseng tamana aturnanrillruat.",
        "translation": "The stopped practicing those practices they had with seals."
    },
    "476": {
        "startTime": 3195.19,
        "endTime": 3198.86,
        "transcript": "Okay, I'll do one, and I hear something different over there.",
        "translation": "Okay, I'll do one, and I hear something different over there."
    },
    "477": {
        "startTime": 3198.868,
        "endTime": 3205.198,
        "transcript": "But Kurt Bell says that after the missionaries came, they stopped on their own.",
        "translation": "But Kurt Bell says that after the missionaries came, they stopped on their own."
    },
    "478": {
        "startTime": 3207.185,
        "endTime": 3209.675,
        "transcript": "Qanqeryugngaunga-qaa?",
        "translation": "May I speak?"
    },
    "479": {
        "startTime": 3209.686,
        "endTime": 3211.336,
        "transcript": "(Ii-i.) Ii-i.",
        "translation": "(Yes.) Okay."
    },
    "480": {
        "startTime": 3211.339,
        "endTime": 3221.779,
        "transcript": "Au͡g'umun wani kegginaanun taqukat, black bear-at wall'u brown bear",
        "translation": "About the faces of bears, black bears or brown bears"
    },
    "481": {
        "startTime": 3221.791,
        "endTime": 3227.571,
        "transcript": "Pitqerraalria wani maaken qanranek kegginaa pitullinikii.",
        "translation": "With the first catch, he evidently applies [saliva] from its mouth to his face."
    },
    "482": {
        "startTime": 3229.296,
        "endTime": 3231.886,
        "transcript": "Wiinga tan'gaurluulua...",
        "translation": "When I was a boy..."
    },
    "483": {
        "startTime": 3231.894,
        "endTime": 3234.864,
        "transcript": "(Kituuyit?) Edward Weiss.",
        "translation": "(Who are you?) Edward Weiss."
    },
    "484": {
        "startTime": 3236.885,
        "endTime": 3242.636,
        "transcript": "Waten pillruatnga, au͡g'um ap'ama:",
        "translation": "They said this to me, my grandfather:"
    },
    "485": {
        "startTime": 3244.062,
        "endTime": 3255.292,
        "transcript": "Tan'gerliq tuqulluku nutgaarluku, tua-i-ll' tuaten qamaken nuaganek kegginaqa mingugtelluku unatenka-llu.",
        "translation": "After shooting and killing a black bear, he'd then have me apply the salive from inside its mouth on my face and hands."
    },
    "486": {
        "startTime": 3255.301,
        "endTime": 3258.791,
        "transcript": "Tua-i-ll' waten qanrullua:",
        "translation": "Then he told me this:"
    },
    "487": {
        "startTime": 3259.306,
        "endTime": 3264.156,
        "transcript": "Anglikuma-gguq pissuryaureskuma",
        "translation": "He said that when I grow up and start hunting"
    },
    "488": {
        "startTime": 3265.574,
        "endTime": 3276.464,
        "transcript": "Pitsaqevkenii-gguq tan'gerlim wall'u tamakut brown bear-am akngirrluni tegukunia",
        "translation": "He said that should a black bear or one of those brown bears get injured and takes me"
    },
    "489": {
        "startTime": 3276.473,
        "endTime": 3281.293,
        "transcript": "Kegginaqa-gguq tangerciqaa nuaminek pimaluni.",
        "translation": "He said it'll see my face covered in its saliva."
    },
    "490": {
        "startTime": 3281.302,
        "endTime": 3285.292,
        "transcript": "Taum-gguq aneryaarvikngaitaanga.",
        "translation": "He said that that [bear] won't breathe on me."
    },
    "491": {
        "startTime": 3285.303,
        "endTime": 3295.663,
        "transcript": "Aneryaallrit nuagit black bear-at tukniqapiartut nuagit yugmun.",
        "translation": "Black bears' breath and saliva are very strong for people."
    },
    "492": {
        "startTime": 3295.668,
        "endTime": 3300.508,
        "transcript": "Taumek waten aneryaarvikluki tuqutelallinikait kegginait puvvluki.",
        "translation": "That's why they can kill by breathing on them, making their faces swell."
    },
    "493": {
        "startTime": 3300.513,
        "endTime": 3302.823,
        "transcript": "Tuaten-gguq pingaitaanga.",
        "translation": "He said it won't do that to me."
    },
    "494": {
        "startTime": 3302.831,
        "endTime": 3306.101,
        "transcript": "Tua-i-llu kinguani",
        "translation": "Then afterwards"
    },
    "495": {
        "startTime": 3306.927,
        "endTime": 3312.117,
        "transcript": "Qaillun tayim' allrakunglua, 25-aarlua",
        "translation": "When I was some age, when I was 25"
    },
    "496": {
        "startTime": 3312.636,
        "endTime": 3316.486,
        "transcript": "Nutecurlagluku tan'gerlim tegullruyaaqaanga.",
        "translation": "I missed my gunshot, and a black bear took me."
    },
    "497": {
        "startTime": 3316.495,
        "endTime": 3323.285,
        "transcript": "Nutka teguluku waten, tau͡gaam kegginamnun aneryaallrunrituq.",
        "translation": "It took my gun like this, but it didn't breath on my face."
    },
    "498": {
        "startTime": 3323.294,
        "endTime": 3326.894,
        "transcript": "Tau͡gaam waten ulurlua aneryaaraqluni.",
        "translation": "Instead, it looked away from me as it breathed."
    },
    "499": {
        "startTime": 3326.906,
        "endTime": 3331.186,
        "transcript": "Tamaa-i tamana alerquutekellrullinia.",
        "translation": "That's what he instructed."
    },
    "500": {
        "startTime": 3331.196,
        "endTime": 3336.186,
        "transcript": "Maa-i-llu cali qavani-w' nunamteńi cali.",
        "translation": "Even now, at least in our village upriver."
    },
    "501": {
        "startTime": 3336.738,
        "endTime": 3342.575,
        "transcript": "Okay, that's Edward Weiss from Kuskokwim.",
        "translation": "Okay, that's Edward Weiss from Kuskokwim."
    },
    "502": {
        "startTime": 3342.586,
        "endTime": 3344.366,
        "transcript": "He said when his grandfather...",
        "translation": "He said when his grandfather..."
    },
    "503": {
        "startTime": 3346.935,
        "endTime": 3357.382,
        "transcript": "Elliin tangrruallrani elpeci older men",
        "translation": "From her point of view of you older men"
    },
    "504": {
        "startTime": 3357.879,
        "endTime": 3364.629,
        "transcript": "Umyuarteqtullrulliniici respect-arluki, qigcikluki pitarkat.",
        "translation": "She thought that you would respect, qigcikluki, animals you hunted."
    },
    "505": {
        "startTime": 3364.638,
        "endTime": 3369.138,
        "transcript": "Maa-i-rpak-gguq-qaa umyuarteqlerpecini",
        "translation": "She asked if now, in your opinion"
    },
    "506": {
        "startTime": 3369.141,
        "endTime": 3377.611,
        "transcript": "Makut kinguliaci tau͡gaten, tau͡gaten-gguq-qaa ayuqluteng piut elpecicetun?",
        "translation": "Your descendants, are they doing that like you now?"
    },
    "507": {
        "startTime": 3377.626,
        "endTime": 3380.126,
        "transcript": "Wall'u-gguq-qaa pinritut?",
        "translation": "Or, she asked, are they not?"
    },
    "508": {
        "startTime": 3380.136,
        "endTime": 3387.496,
        "transcript": "Pinrilkata-gguq-qaa waten umyugartequci: pitarkat nangnayukluki?",
        "translation": "Or if they're not, she asked this: do you think animals will deplete?"
    },
    "509": {
        "startTime": 3390.903,
        "endTime": 3397.523,
        "transcript": "Wanigga wii akiqacuaqaqataraqa apyutii.",
        "translation": "Now, I'm going to give some answer to her question."
    },
    "510": {
        "startTime": 3397.99,
        "endTime": 3407.751,
        "transcript": "Makut seal-at makut un'um imarpiim pitarkai nangllerkaitnek umyugartuyuitua.",
        "translation": "These seals, I don't think of how the animals down from the ocean will be depleted."
    },
    "511": {
        "startTime": 3408.793,
        "endTime": 3417.873,
        "transcript": "Makuneng tau͡gaam tengmiat makut piyagait, kayanguit",
        "translation": "These instead, the birds, their chicks, and their eggs"
    },
    "512": {
        "startTime": 3418.011,
        "endTime": 3429.511,
        "transcript": "Makut yug'enka wii irnianka inerqutuanka waten irniarita tukellrita nalliini:",
        "translation": "I admonish my descendants, my children, like this when their young hatch:"
    },
    "513": {
        "startTime": 3430.575,
        "endTime": 3434.68,
        "transcript": "Angu nutegyaasqevkenaku.",
        "translation": "Never to hunt."
    },
    "514": {
        "startTime": 3435.068,
        "endTime": 3440.133,
        "transcript": "Tamakut-llu piyagauluki pisqevkenaki, mikelnguuluki.",
        "translation": "And never to [hunt] them when they're chicks, when they're small."
    },
    "515": {
        "startTime": 3440.71,
        "endTime": 3452.42,
        "transcript": "Tau͡ga piyaaqengraan, kayimyaaqengraan tamakut aanait waten carraugaqata irniarit inerqutuanka tau͡ga wii pisqevkenaki.",
        "translation": "Though their mothers bring forth a lot, when they have too few chicks, I admonish them against [hunting] them."
    },
    "516": {
        "startTime": 3452.433,
        "endTime": 3462.023,
        "transcript": "Tamakut mikelnguut wii-llu irnianka tamakut tau͡gaten ayuqsugnarqut piyagartun.",
        "translation": "Those children, my children, are probably like those chicks."
    },
    "517": {
        "startTime": 3462.103,
        "endTime": 3465.753,
        "transcript": "Tamakut pitekluki inerqutuanka.",
        "translation": "They are the reason I admonish them."
    },
    "518": {
        "startTime": 3465.768,
        "endTime": 3472.538,
        "transcript": "Irniaqenrilengramki tamakut kayanguit tengmiat piyagait tukraqata.",
        "translation": "Though those birds' eggs aren't my children, when their chicks hatch."
    },
    "519": {
        "startTime": 3473.246,
        "endTime": 3481.376,
        "transcript": "Angturriqvaaraqata-llu kia yuum malingcarluku ayauskaku, ayauteqatallinikaku inerqurciqaqa",
        "translation": "And when they're bigger, if a person is chasing them to another place, I will admonish them"
    },
    "520": {
        "startTime": 3481.379,
        "endTime": 3489.089,
        "transcript": "Angu aanii, aanak ukuk qaqillukek angu pisqevkenaku, tuqutesqevkenakek.",
        "translation": "Its mother, never to kill both it and its mother."
    },
    "521": {
        "startTime": 3489.094,
        "endTime": 3494.194,
        "transcript": "Aanak taukuk aulukestairuciiqniluki taukut irniari.",
        "translation": "The mothers, I tell them their chicks won't have any caretakers."
    },
    "522": {
        "startTime": 3494.321,
        "endTime": 3497.701,
        "transcript": "Tapirviitniluki makut naruyat.",
        "translation": "I say these seagulls don't need anything else."
    },
    "523": {
        "startTime": 3499.56,
        "endTime": 3507.88,
        "transcript": "Naklegnaqniluki tamakut mikelnguuniluki aanaituraluki tamaa-i aulukeskaraunaki pillerkait.",
        "translation": "I said their chicks would be pitiful without any mothers to take care of them."
    },
    "524": {
        "startTime": 3508.337,
        "endTime": 3511.177,
        "transcript": "Taumeng tau͡ga inerqutuanka.",
        "translation": "That's why I admonish them."
    },
    "525": {
        "startTime": 3514.077,
        "endTime": 3518.977,
        "transcript": "Well, he says that for him",
        "translation": "Well, he says that for him"
    },
    "526": {
        "startTime": 3518.984,
        "endTime": 3525.404,
        "transcript": "He doesn't think that there's not much danger to the seals right now.",
        "translation": "He doesn't think that there's not much danger to the seals right now."
    },
    "527": {
        "startTime": 3525.412,
        "endTime": 3530.762,
        "transcript": "But he tells his children about the birds.",
        "translation": "But he tells his children about the birds."
    },
    "528": {
        "startTime": 3530.772,
        "endTime": 3537.972,
        "transcript": "That when birds have, you know, when the eggs are hatching",
        "translation": "That when birds have, you know, when the eggs are hatching"
    },
    "529": {
        "startTime": 3537.983,
        "endTime": 3543.423,
        "transcript": "And the mother, father birds have to take care of them...",
        "translation": "And the mother, father birds have to take care of them..."
    },
    "530": {
        "startTime": 3544.539,
        "endTime": 3547.919,
        "transcript": "Tua-llu cakaninrituq.",
        "translation": "And it's no different."
    },
    "531": {
        "startTime": 3547.935,
        "endTime": 3558.325,
        "transcript": "Wangkuta pissulallruukut, tua-i-llu aanamta pitarput kencikluku, quyakluku cakneq.",
        "translation": "We would hunt, then our mothers would honor our catch, be very thankful for it."
    },
    "532": {
        "startTime": 3558.329,
        "endTime": 3565.849,
        "transcript": "Tua-llu maa-i wangkuta aataurtellriani, taum-llu tua-i aanaulriim nallunritai qetunrangqerrami",
        "translation": "Then now, we who've become fathers, that mother also know them since she has sons"
    },
    "533": {
        "startTime": 3565.852,
        "endTime": 3570.892,
        "transcript": "Qetunrani qangqiirtaqan cakneq quyakluku ciuniularaa.",
        "translation": "When her son catches a ptarmigan, she is very thankful and welcomes it."
    },
    "534": {
        "startTime": 3570.901,
        "endTime": 3573.891,
        "transcript": "Tua-i ikgelkevkenaku.",
        "translation": "She doesn't think it's too little."
    },
    "535": {
        "startTime": 3573.901,
        "endTime": 3579.301,
        "transcript": "Pitai tamalkuita quyakluki kencikluki-llu.",
        "translation": "She is thankful for and honors everything he catches."
    },
    "536": {
        "startTime": 3579.311,
        "endTime": 3587.461,
        "transcript": "Sagcetevkenaki, tutmallermun-llu pisqevkenaki avaken inerquutekngamteki tua-i.",
        "translation": "She doesn't leave them strewn, or where people have trod since they're are our ancient admonishments."
    },
    "537": {
        "startTime": 3588.351,
        "endTime": 3591.071,
        "transcript": "He's... ernerpak maa-i-rpak...",
        "translation": "He's... these days..."
    },
    "538": {
        "startTime": 3591.081,
        "endTime": 3595.171,
        "transcript": "Ermigciquq. Wiinga tamana nalluaqa.",
        "translation": "[S]he will was their face. I don't know that."
    },
    "539": {
        "startTime": 3595.18,
        "endTime": 3603.34,
        "transcript": "Wangkuta tang aanaulriani ayagyuaqlirnerpeceńi qanrutestailngukut.",
        "translation": "You see, we mothers who are younger than you have no instructors."
    },
    "540": {
        "startTime": 3603.466,
        "endTime": 3614.166,
        "transcript": "Atawauyartuq-qaa makut maani qanerceskuvciki KYUK News",
        "translation": "Would it be good if you here had them speak on KYUK News"
    },
    "541": {
        "startTime": 3614.172,
        "endTime": 3620.342,
        "transcript": "Or, time-amek cikiqerluki ayuqucirturluta wangkuta?",
        "translation": "Or, give them time to instruct us?"
    },
    "542": {
        "startTime": 3620.35,
        "endTime": 3624.48,
        "transcript": "Yuungnaqellriit amllertut irniaput. Nalluukut.",
        "translation": "We have many children trying to provide for themselves. We don't know."
    },
    "543": {
        "startTime": 3624.497,
        "endTime": 3627.647,
        "transcript": "Wiinga-llu irnianka nalluvkaranka.",
        "translation": "I also leave my children in ignorance."
    },
    "544": {
        "startTime": 3627.657,
        "endTime": 3632.147,
        "transcript": "Tua-i-wa niicuilama akaurcan aanairuyuciqa.",
        "translation": "It's because I don't hear of them since it's been a long time since I've lost my mother."
    },
    "545": {
        "startTime": 3632.155,
        "endTime": 3636.735,
        "transcript": "Ak'allaraat makut wiinga qalartellrit assikanka.",
        "translation": "I like when these older people speak."
    },
    "546": {
        "startTime": 3636.744,
        "endTime": 3642.134,
        "transcript": "Piciugut. Maa-i cali piuyaaqut tau͡gaam tamartut.",
        "translation": "They're true. They still are now, but they're disappearing."
    },
    "547": {
        "startTime": 3642.148,
        "endTime": 3646.888,
        "transcript": "Kass'at elitnaurutet pugelriit iptait.",
        "translation": "Western teachings that have appeared are eclipsing them."
    },
    "548": {
        "startTime": 3647.046,
        "endTime": 3651.566,
        "transcript": "Atawauyartuq time-amek Kass'amta cikikaqakut.",
        "translation": "It would be good of the Caucasians among us gave us time."
    },
    "549": {
        "startTime": 3651.578,
        "endTime": 3662.568,
        "transcript": "KYUK radio wall'u news-atgun ciulirneq qanqaquni elitnaurluki irniaput ikayurciqaakut.",
        "translation": "If an elder speaks on KYUK radio or on the news to teach our children, that will help us."
    },
    "550": {
        "startTime": 3664.132,
        "endTime": 3669.882,
        "transcript": "Time-amek cikiqerceskatki quyanaqsartuq.",
        "translation": "We would be thankful if they gave them time."
    },
    "551": {
        "startTime": 3669.893,
        "endTime": 3672.683,
        "transcript": "Amllertuq elitarkaq.",
        "translation": "There's much to learn."
    },
    "552": {
        "startTime": 3673.469,
        "endTime": 3676.069,
        "transcript": "Quyana, Eliza.",
        "translation": "Thank you, Eliza."
    },
    "553": {
        "startTime": 3676.483,
        "endTime": 3683.943,
        "transcript": "Alerqutuitkut-am pissuqata'arqamta tan'gerlinek...",
        "translation": "They instruct us when we're going to hunt black bears..."
    },
    "554": {
        "startTime": 3688.579,
        "endTime": 3694.159,
        "transcript": "...muragmek ayarurkamteńek pisqelluta.",
        "translation": "...that we should get a wooden staff."
    },
    "555": {
        "startTime": 3695.483,
        "endTime": 3698.363,
        "transcript": "Tauna-gguq ayaruq",
        "translation": "They said that that staff"
    },
    "556": {
        "startTime": 3698.37,
        "endTime": 3706.192,
        "transcript": "Nauw' ayaruq uksuarmi-ll' atuulria tua-i mamkilngurmun cikumun wall' aarnarqellrianun.",
        "translation": "You know how a staff is useful in the fall for thin ice or for dangerous areas."
    },
    "557": {
        "startTime": 3706.208,
        "endTime": 3712.458,
        "transcript": "Tauna-am avani qau͡gkumiuni alerquutnguuq",
        "translation": "That is a traditional instruction up north"
    },
    "558": {
        "startTime": 3712.466,
        "endTime": 3720.576,
        "transcript": "Ingrinun tan'gerlimek pissuqataqumta wall'u ayagakumta ayaruq tauna tegumiaquraasqelluku.",
        "translation": "If we go to hunt a black bear in the mountains or travel anywhere, to always keep that staff on hand."
    },
    "559": {
        "startTime": 3721.895,
        "endTime": 3729.881,
        "transcript": "Tua-i-llam ayagpakarluta tan'gerlim curukarciqliniakut.",
        "translation": "Then when we travel for long enough, a black bear will attack us."
    },
    "560": {
        "startTime": 3731.439,
        "endTime": 3739.609,
        "transcript": "Tua-i-gguq makut tan'gerlit yugtun ayuqut. Unatemcetun waten tegutuut.",
        "translation": "They said that these black bears are like people. They grab like this like our hands."
    },
    "561": {
        "startTime": 3740.307,
        "endTime": 3748.667,
        "transcript": "Egmian-gguq wani nutegput teguvailgaku ayarumek cikiqilaput, cikiqilarput.",
        "translation": "They said that before it takes our gun, that we should give it a staff right away."
    },
    "562": {
        "startTime": 3748.673,
        "endTime": 3751.953,
        "transcript": "Tua-i-gguq taum anirturciqaakut.",
        "translation": "They said that that will save us."
    },
    "563": {
        "startTime": 3751.964,
        "endTime": 3757.134,
        "transcript": "Nutaan cikirluku, teguqerarkauluku taum, wangkuta-ll' nutgarkauluku.",
        "translation": "Give it to [the bear], it will take it, and we'll shoot it."
    },
    "564": {
        "startTime": 3765.13,
        "endTime": 3769.92,
        "transcript": "Angalkungqellruukut. Angalkungqelallrulliniukut.",
        "translation": "We had shamans. We evidently had shamans."
    },
    "565": {
        "startTime": 3771.45,
        "endTime": 3776.85,
        "transcript": "Tamakut tamaani piciruitnek wangkuta ap'laraput.",
        "translation": "We refer to those things back then as superstitions."
    },
    "566": {
        "startTime": 3777.285,
        "endTime": 3782.525,
        "transcript": "Piciruitnguluteng. Tua-i angalkurtauluteng.",
        "translation": "They're superstitions. They're from shamans."
    },
    "567": {
        "startTime": 3782.703,
        "endTime": 3787.753,
        "transcript": "Wait, wait, tarringenritaqa tauna. \"Piciruiq?\"",
        "translation": "Wait, wait, I don't understand that. \"Piciruiq?\""
    },
    "568": {
        "startTime": 3787.934,
        "endTime": 3791.794,
        "transcript": "Iciw' tua-i piciuvkenani-w', angalkurtauluni tau͡gaam.",
        "translation": "You know, it's not true, but is from shamans."
    },
    "569": {
        "startTime": 3791.8,
        "endTime": 3795.24,
        "transcript": "Angalkuq tuunrangayagtauluni wangkuta apqemteńek.",
        "translation": "A shaman is of the devil, by what we call it."
    },
    "570": {
        "startTime": 3795.249,
        "endTime": 3797.449,
        "transcript": "Tamakut tamaa-i",
        "translation": "Those things"
    },
    "571": {
        "startTime": 3798.238,
        "endTime": 3806.288,
        "transcript": "Ukvengamta mat'umun Agayutmun tamakut tamaa-i amllellriit iinrut-llu pegingaut tayima.",
        "translation": "When we got faith in God, many of those things, including medicine, have been given up."
    },
    "572": {
        "startTime": 3806.29,
        "endTime": 3807.95,
        "transcript": "Pegingariut.",
        "translation": "They're given up now."
    },
    "573": {
        "startTime": 3808.903,
        "endTime": 3816.583,
        "transcript": "Tua-i-llu maa-i nunamteńi unani ceńarmiuni",
        "translation": "Then in our village now down on the coast"
    },
    "574": {
        "startTime": 3818.284,
        "endTime": 3825.524,
        "transcript": "Man'a maklagcaraq pegcuitarput.",
        "translation": "We don't give up hunting for seals."
    },
    "575": {
        "startTime": 3825.531,
        "endTime": 3839.032,
        "transcript": "Maa-i ayagyuarunrilengraan-llu allrakuaqan up'nerkami pitqerraarqan maklagmek",
        "translation": "Now, even if one is not young, ever year in the spring, when he catches the first seal"
    },
    "576": {
        "startTime": 3839.042,
        "endTime": 3842.262,
        "transcript": "Cali allragni pitellruluni",
        "translation": "Also having caught one the year before"
    },
    "577": {
        "startTime": 3842.272,
        "endTime": 3847.172,
        "transcript": "Ciuqlirmek angun pitqerraartura'arqan qamigatuli",
        "translation": "When the first man who goes spring seal hunting makes the first catch"
    },
    "578": {
        "startTime": 3848.565,
        "endTime": 3852.032,
        "transcript": "Maa-i apqemteńek uqiqurrlainartuq.",
        "translation": "As we call it now, they distribute it."
    }
};